import { useState, useEffect, useRef } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Helmet } from 'react-helmet-async';
import { Link as RouterLink, useNavigate, NavLink, useParams, useLocation } from 'react-router-dom';
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import html2canvas from 'html2canvas';
// import jsPDF from 'jspdf'; 
import { jsPDF as JsPDF } from 'jspdf'; 


// @mui
import { styled } from '@mui/material/styles';
import { Button, Typography, Container, Box, Modal } from '@mui/material';
import config from "../../config";
import { encryptData } from '../../utils/cryptoUtils';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import "bootstrap-icons/font/bootstrap-icons.css";
import '../common.scss';

import * as userActions from "../../actions/userActions";
import AccessDenied from '../common/AccessDenied';

import * as leadActions from "../../actions/leadActions";
import DisbursementMemoPage from './DisbursementMemoPage';
// ----------------------------------------------------------------------

const StyledContent = styled('div')(({ theme }) => ({
    maxWidth: 480,
    margin: 'auto',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------


const SanctionLetter = (props) => {
    const { leadId, id } = useParams();
    const location = useLocation();
    const { actions, usersData, fetchLeadIdDocument, allLeadDocumentByLeadData, userRoleType, isActive,leadInfo,backToLeadHandler,enableCamDetailsHandler,selectionVersioningID } = props;
    const { register, handleSubmit, formState: { errors }, setValue, reset } = useForm();
    const navigate = useNavigate();

    const [allUsers, setAllUsers] = useState([]);
    const [selectedDocumentFiles, setSelectedDocumentFiles] = useState([]);
    const [getLeadId, setLeadId] = useState('');
    const [allUploadLeadDocument, setAllUploadLeadDocument] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState('');
    const formRef = useRef(null);
    const [propLeadId, setPropLeadId] = useState('');
    const [allDocumentTypeData, setAllDocumentTypeData] = useState([]);
    const [open, setOpen] = useState(false);
    const [viewModalInfo, setViewModalInfo] = useState([]);
    const [isVerifyDocChecked, setIsVerifyDocChecked] = useState(false);

    const [activeAllSancationDocs, setActiveAllSancationDocs] = useState([]);
    const [allLeadCheckLists, setAllLeadCheckLists] = useState([]);
    const [activeAccordionSections, setActiveAccordionSections] = useState([]);

      const [anchorCategories, setAnchorCategories] = useState([]);  
      const [speciallyAbledArr, setSpeciallyAbledArr] = useState([]);
      const [residenceTypesArr, setResidenceTypesArr] = useState([]);
      const [bankingUpiArr, setBankingUpiArr] = useState([]);
      const [constitutionArr, setConstitutionArr] = useState([]);
      const [customerTypeArr, setCustomerTypeArr] = useState([]);
      const [vehicleMakerArr, setVehicleMakerArr] = useState([]);
      const [vehicleUseArr, setVehicleUseArr] = useState([]);
      const [insuranceArr, setInsuranceArr] = useState([]);
      const [vehicleModelsArr, setVehicleModelsArr] = useState([]);
      const [businessValidationProofArr, setBusinessValidationProofArr] = useState([]);
      const [turnoverIncomeArr, setTurnoverIncomeArr] = useState([]);
      const [workingCapitalCycleArr, setWorkingCapitalCycleArr] = useState([]);
      const [addedLeadCoapplicantGuarantorRows, setAddedLeadCoapplicantGuarantorRows] = useState([]);
      const [coapplicantGuarantorRows, setCoapplicantGuarantorRows] = useState([]);
      const [accountTypeArr, setAccountTypeArr] = useState([]);
      const [crifDetails, setCrifDetails] = useState([]);  
      const [bankDetails, setBankDetails] = useState([]); 
      const [camApprovalHistory, setCamApprovalHistory] = useState([]); 
      
        const [cAMMarginMoney, setCAMMarginMoney] = useState(0);
        const [annualIrr, setAnnualIrr] = useState(null);
        const [error, setError] = useState(null);
        const [showSanctionNote, setShowSanctionNote] = useState('');
        const [sanctionApproveLatestStatus, setSanctionApproveLatestStatus] = useState(0);
        const [sanctionApproveAndSendMailLatestStatus, setSanctionApproveAndSendMailLatestStatus] = useState(0);
        const [approveBtnAction, setApproveBtnAction] = useState(0);
        const [sendEmailBtnAction, setSendEmailBtnAction] = useState(0);
        const [openRejectAmt, setOpenRejectAmt] = useState(false);
        const [proposedRejectAmt, setproposedRejectAmt] = useState('');
        const [noOfAssetsToBeFinancedAfter, setNoOfAssetsToBeFinancedAfter] = useState('');
        const [multiofTotalAssetsNoofAssets, SetMultiofTotalAssetsNoofAssets] = useState('');
    
    const [isFIOpen, setIsFIOpen] = useState(false);
    const [isMiscOpen, setIsMiscOpen] = useState(false);
    const [isApplicantOpen, setIsApplicantOpen] = useState(false);
    const [isCoApplicantOpen, setIsCoApplicantOpen] = useState(false);
    const [isGuarantorOpen, setIsGuarantorOpen] = useState(false);
    const [sanctionFormStatus, setSanctionFormStatus] = useState(false);
    const [sanctionFormActiveTab, setSanctionFormActiveTab] = useState('sanction_letter');
    const [enableUpdatePdfDetails, setEnableUpdatePdfDetails] = useState(false);
    const [refNo, setRefNo] = useState('');
    const [insuranceFor, setInsuranceFor] = useState('For insurance by ckers');
    const [dealerSubvention, setDealerSubvention] = useState('Dealer Subvention');

    const [insuranceForValue, setInsuranceForValue] = useState('');
    const [dealerSubventionValue, setDealerSubventionValue] = useState('');  

    const [loanAmountValue, setLoanAmountValue] = useState('');
    const [processingFeeOnFinanceAmountPlusGSTValue, setProcessingFeeOnFinanceAmountPlusGSTValue] = useState('');
    const [lessProcessingFeeIncludingGSTValue, setLessProcessingFeeIncludingGSTValue] = useState('');
    const [lessInsuranceByKotakMahindraValue, setLessInsuranceByKotakMahindraValue] = useState('');

    const [lessPreEmiTill5THJanValue, setLessPreEmiTill5THJanValue] = useState('');
    const [fileChargeValue, setFileChargeValue] = useState(''); 

    const [netDisbursementValue, setNetDisbursementValue] = useState('');
    const [nameOfSupplierDealerValue, setNameOfSupplierDealerValue] = useState(''); 

    const [exShowroomPriceValue, setExShowroomPriceValue] = useState('');
    const [insuranceAmounByDealerValue, setInsuranceAmounByDealerValue] = useState(''); 
    const [totalOnRoadPriceValue, setTotalOnRoadPriceValue] = useState(''); 
    const [assetValueVehicleVehiclesValue, setAssetValueVehicleVehiclesValue] = useState('');
    const [noOfAssetValue, setNoOfAssetValue] = useState('');
    const [totalDownPaymentByCustomerValue, setTotalDownPaymentByCustomerValue] = useState('');
    const [isReadyToModify, setIsReadyToModify] = useState(true);
    
 
    const [sourceDealerDetails, setSourceDealerDetails] = useState(`1. Complete and filled application form required.<br />2. E-Nach activation confirmation required before disbursal.<br />3. Down Payment proof required.<br />4. All KYC self-attested and OSV done required.<br />5. Zero Depreciation Insurance required before disbursal (Insurance IDV equal and more than loan amount. 1% deviation is acceptable due to market conditions).<br />6. Applicant clear KYC and Banking required with OSV before disbursal.`);
    const [currentDate, setCurrentDate] = useState(new Date());
    const [leadCity, setLeadCity] = useState('');
    const [leadName, setLeadName] = useState('');
    const [leadAddress, setLeadAddress] = useState('');
    const [camDetails, setCamDetails] = useState([]);
    const [savedSanctionDetailsInfo, setSavedSanctionDetailsInfo] = useState([]);
    
    const [lessPreEmiTill5thLabel, setLessPreEmiTill5thLabel] = useState('Pre-EMI Till 5TH');
    const [amountOfProcessingFee, setAmountOfProcessingFee] = useState(0);
    const [fileChargeExcludingGst, setFileChargeExcludingGst] = useState(0);
    const [fileChargeExcludingGstAmt, setFileChargeExcludingGstAmt] = useState(0);
    const [lessProcessingFeeExcludingGST, setLessProcessingFeeExcludingGST] = useState(0);
    const [payableTotheREAmount, setPayableTotheREAmount] = useState(0);
    const [payableToThirdPartyRoutedThroughRE, setPayableToThirdPartyRoutedThroughRE] = useState(0);

    
    const [feeChargesPayable, setFeeChargesPayable] = useState(0);
    const [totalFeeChargesPayable, setTotalFeeChargesPayable] = useState(0);

    const [dearlerSubventionDedcuteAmount, setDearlerSubventionDedcuteAmount] = useState('');
    const [aprValue, setAprValue] = useState(0);

    const [totalMarginMoneyReceiptAmt, setTotalMarginMoneyReceiptAmt] = useState(0);
    const [netDisbursementAmt, setNetDisbursementAmt] = useState(0);
    const [emiAllVehicle, setEmiAllVehicle] = useState(0);
    const [sLTenure, setSLTenure] = useState(0);

    const [viewDetailsOpen, setViewDetailsOpen] = useState(false);
    const [viewDetailsModalInfo, setViewDetailsModalInfo] = useState([]);

    const [loanAmountSchedule, setLoanAmountSchedule] = useState(0);
    const [interestRateSchedule, setInterestRateSchedule] = useState(0);  
    const [loanDurationSchedule, setLoanDurationSchedule] = useState(0);  
    const [paymentsPerYearSchedule, setPaymentsPerYearSchedule] = useState(0); 
    const [downloadPdfType, setDownloadPdfType] = useState('client');  

    useEffect(() => { 
        // check user is logged-in or not
        const authToken = localStorage.getItem('authToken');
        if (authToken === null) {
            navigate('/login');
        }

        const obj = { 'start': '0', 'length': config.MAX_RECORDS };
        const requestData = encryptData(obj);
        actions.usersData(requestData);
        if (usersData.success) {
            setAllUsers(usersData.data);
        }
    }, []);

    const formattedDate = currentDate.toLocaleDateString('en-IN', {
         year: 'numeric',
        month: 'numeric',
        day: 'numeric',
      });

     

      function calculateAPR(tenureMonths, emi, netDisbursement) {
            const maxIterations = 100;
            const precision = 1e-6;

            // Validate inputs
            if (
                tenureMonths <= 0 ||
                emi <= 0 ||
                netDisbursement <= 0 ||
                Number.isNaN(tenureMonths) ||
                Number.isNaN(emi) ||
                Number.isNaN(netDisbursement)
            ) {
                return 0; // or return 'Invalid input' if you prefer
            }

            let rate = 0.1 / 12; // initial guess (10% annually)
            let iteration = 0;

            while (iteration < maxIterations) {
                let npv = 0;
                let derivative = 0;

                for (let i = 1; i <= tenureMonths; i += 1) {
                    npv += emi / ((1 + rate) ** i);
                    derivative += -i * emi / ((1 + rate) ** (i + 1));
                }

                npv -= netDisbursement;

                const newRate = rate - npv / derivative;

                if (Math.abs(newRate - rate) < precision) {
                    rate = newRate;
                    break;
                }

                rate = newRate;
                iteration += 1;
            }

            return (rate * 12 * 100).toFixed(2); // Return APR as percentage
        }

        

        const roundNumber = (num) => {
        if (!num && num !== 0) return 0; 
        return Math.round(num);
      };

        const generateSchedule = () => {
            const principal = parseFloat(loanAmountSchedule);
            const annualRate = parseFloat(interestRateSchedule) / 100;
            const totalPayments = loanDurationSchedule;
            const ratePerPeriod = annualRate / 12; 

           /* const principal = parseFloat(430000);
            const annualRate = parseFloat(20.82) / 100;
            const totalPayments = 42;
            const ratePerPeriod = annualRate / 12; */
 
            const schedule = [];
            const payment = principal * ratePerPeriod / (1 - (1 + ratePerPeriod) ** -totalPayments);
 

            let remainingBalance = principal;

            for (let i = 1; i <= totalPayments; i += 1) {
            const interest = remainingBalance * ratePerPeriod;
            const principalPayment = payment - interest;
            remainingBalance -= principalPayment;

            schedule.push({
                paymentNumber: i,
                payment: roundNumber(payment).toFixed(2),
                interest: roundNumber(interest).toFixed(2),
                principal: roundNumber(principalPayment).toFixed(2),
                balance: remainingBalance > 0 ? roundNumber(remainingBalance).toFixed(2) : '0.00'
            });
            }

            return schedule;
        };


    const schedule = generateSchedule();

      
      
      const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const formatDateForValue = (date) => {
        if (!date || Number.isNaN(new Date(date).getTime())) {
            return '';  // Return an empty string for invalid or empty dates
        }
    
        const newDate = new Date(date);
        const year = newDate.getFullYear();
        const month = String(newDate.getMonth() + 1).padStart(2, '0');
        const day = String(newDate.getDate()).padStart(2, '0');
    
        return `${day}-${month}-${year}`;
    };

    const formatOnlyMonthYearValue = (date) => {
        if (!date || Number.isNaN(new Date(date).getTime())) {
            return '';  // Return an empty string for invalid or empty dates
        }
    
        const newDate = new Date(date);
        const year = newDate.getFullYear();
        const monthName = newDate.toLocaleString('en-US', { month: 'long' }); // Get full month name
    
        return `${monthName} ${year}`;
    };


    const clickCcmTab = () => {      
        backToLeadHandler('cam');
        enableCamDetailsHandler(true); 
        const timer = setTimeout(() => {
            const divElement = document.getElementById("pills-disbursement_memo-tab");
            if (divElement) {
              divElement.click(); 
            }
          }, 2000);       
          return () => clearTimeout(timer); 
      };

      useEffect(() => { 
        if (leadInfo?.data?.length > 0) {

            const name = leadInfo.data[0]?.name;
            setLeadName(name);

            const city = leadInfo.data[0]?.city;
            setLeadCity(city);

            const fullAddress = leadInfo.data[0]?.full_address;
            setLeadAddress(fullAddress);

            console.log("lead info - ", leadInfo?.data);
        } 
        
      }, [leadInfo]); 


    const getSanctionConfigData = async (action='',notes='') => {

        let actionStatus = '0';
        let submitStatus =  true;
         
        if(action ==='approve'){
            actionStatus = '1';
            if(notes ===''){
                toast.error("Notes is required.", {
                    position: "top-right",
                });
                submitStatus =  false;
            }
        }else if(action ==='reject'){
            actionStatus = '2';
    
              if(notes ===''){
                  toast.error("Notes is required.", {
                      position: "top-right",
                  });
                  submitStatus =  false;
              }
            }else if(action ==='reversal'){
                actionStatus = '3';
        
                  if(notes ===''){
                      toast.error("Notes is required.", {
                          position: "top-right",
                      });
                      submitStatus =  false;
                  }      

            } 
            
            if(submitStatus){
            if (id !== undefined) {
            setPropLeadId(atob(id));
            setLeadId(propLeadId);
            let readyToSubmit = true;

            const additionalDetails = {"exShowroomPriceValue" : exShowroomPriceValue, 'insuranceAmounByDealerValue' : insuranceAmounByDealerValue, "totalOnRoadPriceValue" : totalOnRoadPriceValue,"loanAmountValue" : loanAmountValue, "processingFeeOnFinanceAmountPlusGSTValue" : processingFeeOnFinanceAmountPlusGSTValue,"lessProcessingFeeIncludingGSTValue":lessProcessingFeeIncludingGSTValue,"lessInsuranceByKotakMahindraValue" : lessInsuranceByKotakMahindraValue, "lessPreEmiTill5THJanValue" : lessPreEmiTill5THJanValue,"fileChargeValue" :fileChargeValue, "netDisbursementValue" : netDisbursementValue,"nameOfSupplierDealerValue" : nameOfSupplierDealerValue, "insuranceFor" : insuranceFor,"dealerSubvention" : dealerSubvention,"insuranceForValue" :insuranceForValue,"dealerSubventionValue" :dealerSubventionValue,"assetValueVehicleVehiclesValue" : assetValueVehicleVehiclesValue, "noOfAssetValue":noOfAssetValue, "totalDownPaymentByCustomerValue" : totalDownPaymentByCustomerValue} 
 

            let obj = { 'start': '0', 'length': config.MAX_RECORDS, "lead_id": atob(id),"action_status":actionStatus,'notes' :notes,"sendEmail" : sendEmailBtnAction,"additionalDetails":additionalDetails, version_id : selectionVersioningID , 'userRoleType' : userRoleType};
            if(enableUpdatePdfDetails){
                
                if(refNo === ''){
                    toast.error("Ref No is required.", {
                        position: "top-right",
                    });
                    readyToSubmit = false;
                } else if( sourceDealerDetails === '' ){
                    toast.error("Source dealer details is required.", {
                        position: "top-right",
                    });
                    readyToSubmit = false;
                }   
                
                obj = { 'start': '0', 'length': config.MAX_RECORDS, "lead_id": atob(id),'sourceDealerDetails' : sourceDealerDetails, "refNo" : refNo , "enableUpdatePdfDetails" : enableUpdatePdfDetails ,"action_status":actionStatus,'notes' :notes,"sendEmail" : sendEmailBtnAction,"additionalDetails":additionalDetails , version_id : selectionVersioningID , 'userRoleType' : userRoleType}; 
            } 

            if(readyToSubmit) {
                // console.log("obj lead id- ", obj);
                const requestData = encryptData(obj);
                const response = actions.getSanctionConfigData(requestData);

                response.then((result) => {
                    setOpenRejectAmt(false);
                    setApproveBtnAction(0);
                    setSendEmailBtnAction(0);
                    // console.log("Promise resolved -  source data:", result); 
                    if (result.data.success === 1) {
                        const resultArr = result.data.data;


                        const uniqueDocSections = [...new Set(resultArr.activeAllSancationDocs.map(doc => doc.doc_section))];

                        console.log(" ---- setActiveAccordionSections", uniqueDocSections);

                        setActiveAccordionSections(uniqueDocSections);

                        setActiveAllSancationDocs(resultArr.activeAllSancationDocs);

                        // get lead assigned checklists
                        const checkListsResults = resultArr?.all_checklists;
                        const checkListsResultsArr = Object.keys(checkListsResults).map(
                            (key) => checkListsResults[key]
                        );
                        setAllLeadCheckLists(checkListsResultsArr);
                        // alert('here');
                        const sanctionDetailsInfo = resultArr?.sanction_details_info; 
                        
                        setSavedSanctionDetailsInfo(sanctionDetailsInfo);
                        if(sanctionDetailsInfo !== null ){
                         
                            console.log("sanctionDetailsInfo?.additionalDetails = ",sanctionDetailsInfo?.additionalDetails);
                        if(sanctionDetailsInfo?.additionalDetails){
                            const parsedData = JSON.parse(sanctionDetailsInfo?.additionalDetails);
                            
                            if(parsedData?.exShowroomPriceValue !== '' && parsedData?.exShowroomPriceValue !== undefined) {
                                if(parsedData?.insuranceFor !== '') {
                                    setInsuranceFor(parsedData?.insuranceFor);
                                }
                                if(parsedData?.dealerSubvention !== '') {
                                    setDealerSubvention(parsedData?.dealerSubvention);
                                }

                                setExShowroomPriceValue(parsedData?.exShowroomPriceValue);
                                setInsuranceAmounByDealerValue(parsedData?.insuranceAmounByDealerValue);  
                                setTotalOnRoadPriceValue(parsedData?.totalOnRoadPriceValue);
                                
                                setLoanAmountValue(parsedData?.loanAmountValue); 
                                setProcessingFeeOnFinanceAmountPlusGSTValue(parsedData?.processingFeeOnFinanceAmountPlusGSTValue);
                                setLessProcessingFeeIncludingGSTValue(parsedData?.lessProcessingFeeIncludingGSTValue);
                                setLessInsuranceByKotakMahindraValue(parsedData?.lessInsuranceByKotakMahindraValue);
                                setLessPreEmiTill5THJanValue(parsedData?.lessPreEmiTill5THJanValue);
                                setFileChargeValue(parsedData?.fileChargeValue);
                                setNetDisbursementValue(parsedData?.netDisbursementValue);
                                setNameOfSupplierDealerValue(parsedData?.nameOfSupplierDealerValue);

                                setInsuranceForValue(parsedData?.insuranceForValue);
                                setDealerSubventionValue(parsedData?.dealerSubventionValue);

                                setAssetValueVehicleVehiclesValue(parsedData?.assetValueVehicleVehiclesValue);
                                setNoOfAssetValue(parsedData?.noOfAssetValue);
                                setTotalDownPaymentByCustomerValue(parsedData?.totalDownPaymentByCustomerValue);
 
                        }
                                
                        }    
                            
                        if(sanctionDetailsInfo?.refNo){
                            setRefNo(sanctionDetailsInfo.refNo);
                        }
                        if(sanctionDetailsInfo?.sourceDealerDetails){
                            setSourceDealerDetails(sanctionDetailsInfo.sourceDealerDetails);
                            
                        }

                        
                        if (sanctionDetailsInfo.refNo !== '' ) {

                            setSanctionApproveAndSendMailLatestStatus(sanctionDetailsInfo?.send_mail_status);
                            
                            setSanctionApproveLatestStatus(sanctionDetailsInfo?.action_status);
                            if(sanctionDetailsInfo?.action_status < 1){
                             const showResNote = `Sent to Credit Head On ${sanctionDetailsInfo.created_at} by ${sanctionDetailsInfo.createdByName}`;
                             setShowSanctionNote(showResNote);
                           }
                  
                           
                           if (sanctionDetailsInfo?.action_status === '1') {
                            
                            
                            let showResNote = `Sanction Approved By Credit Head On ${sanctionDetailsInfo?.created_at} by ${sanctionDetailsInfo.createdByName}`;

                            if (sanctionDetailsInfo?.send_mail_status === '1') {
                                showResNote = `The sanction has been approved, and the email was sent successfully On ${sanctionDetailsInfo?.created_at} by ${sanctionDetailsInfo.createdByName}`;
                            }

                            
                             setShowSanctionNote(showResNote);
                         }
                 
                           if(sanctionDetailsInfo?.action_status === '2'){
                             const showResNote = `Sanction Rejected By Credit Head On ${sanctionDetailsInfo.created_at} by ${sanctionDetailsInfo.createdByName},  Comment : ${sanctionDetailsInfo.notes} by ${sanctionDetailsInfo.createdByName}`;
                             setShowSanctionNote(showResNote);
                           }

                           if(sanctionDetailsInfo?.action_status === '3'){
                            const showResNote = `Reversal request sent By Credit On ${sanctionDetailsInfo.created_at} by ${sanctionDetailsInfo.createdByName},  Comment : ${sanctionDetailsInfo.notes} by ${sanctionDetailsInfo.createdByName}`;
                            setShowSanctionNote(showResNote);
                          } 

                         }
                        }

                        
                        if(enableUpdatePdfDetails){
                            setEnableUpdatePdfDetails(false); 
                        }
                    }

                    getCAMDetailsData();
                }).catch((error) => {
                    //  console.error("Promise rejected -  source data :", error); 
                });
            }
        }
    }
     
    };

    function calculateIRR(cashFlows, guess = 0.1) {
        const maxIteration = 1000;
        const precision = 1e-7;
        let rate = guess;

        for (let iter = 0; iter < maxIteration; iter+=1) {
            let npv = 0;
            let derivative = 0;

            for (let t = 0; t < cashFlows.length; t+=1) {
            npv += cashFlows[t] / (1 + rate) ** t;
            derivative -= t * cashFlows[t] / (1 + rate) ** (t + 1);
            }

            const newRate = rate - npv / derivative;

            if (Math.abs(newRate - rate) < precision) {
            return newRate;
            }

            rate = newRate;
        }

        throw new Error("IRR calculation did not converge");
        }

    const getCAMDetailsData = async () => {
        if (!id) {
          console.error("Error: ID is undefined.");
          return;
        }
      
        try {
          const decodedId = atob(id);
           
          const obj = {
            start: '0',
            length: config.MAX_RECORDS,
            lead_id: decodedId,
            with_additional_info:'yes',
            api_calling_module : "sanction_module",
            version_id : selectionVersioningID
          }; 
       
          setCoapplicantGuarantorRows(addedLeadCoapplicantGuarantorRows);
          const requestData = encryptData(obj);
          const result = await actions.getCAMDetails(requestData);
      
          if (result?.data?.success === 1) {
            const results = result.data.data?.data || {};
            const resultArr = Object.values(results);
            
            if (resultArr?.length > 0 && resultArr[0]?.cam_details) {
                const camDetails = resultArr[0].cam_details; 
                const jsonData = JSON.parse(camDetails);  
                
                if (jsonData?.dob === '0000-00-00') {
                  jsonData.dob = '';
                }

                setCamDetails(jsonData); 

                 let gstAmount = 0;
                 if(jsonData?.dmemo_processing_fee_including_gst !== ''){
                    gstAmount = (jsonData?.dmemo_processing_fee_including_gst * 18) / 118; 
                  }

                setAmountOfProcessingFee(roundNumber(gstAmount));

                
                let fileGstAmount = 0;
                 if(jsonData?.cam_file_charges !== ''){
                   fileGstAmount = (jsonData?.cam_file_charges * 18) / 118; 
                  }  
                setFileChargeExcludingGst(roundNumber(fileGstAmount));

                const fileChargeIncludingGst = Number(jsonData?.cam_file_charges) || 0;
                 const fileChargeExcludingGst = fileChargeIncludingGst - fileGstAmount;
                setFileChargeExcludingGstAmt(fileChargeExcludingGst);
 

                const tenure = sLTenure;  // 10;  
                const emiAmt =  emiAllVehicle; // 10987.73; // Monthly EMI
                const disbursement =  netDisbursementAmt; // 97097.26 // Net Disbursement

               /* alert(tenure);
                alert(emi);
                alert(disbursement); */
               // const apr = calculateAPR(tenure, emiAmt, disbursement);
               // setAprValue(apr);

                const financeAmount = jsonData?.irr_finance_amount || 0;
                const processingFeeVal = jsonData?.dmemo_processing_fee_on_finance_amount_plus_gst;

                const emi = emiAmt;
                const tenureMonths = sLTenure;
                const processingFee = (Number(financeAmount) * processingFeeVal) /100;
                const loanAmount = jsonData?.irr_finance_amount || 0;
                const disbursedAmount = loanAmount - processingFee;

                const cashFlows = [-disbursedAmount];
                for (let i = 1; i <= tenureMonths; i+=1) {
                cashFlows.push(emi);
                }

                let result = 0;
                try {
                const irrMonthly = calculateIRR(cashFlows);
                result = irrMonthly * 12 * 100; // monthly to annual APR
               // console.log("APR:", result.toFixed(2) + "%");

               if(noOfAssetValue > 0){
                result /= Number(noOfAssetValue);
               }
                } catch (err) {
                     console.error("IRR calculation failed monthly to annual APR :", err);
                } 

                setAprValue(result.toFixed(2));

                if(jsonData?.dmemo_reference_no !==''){
                    setRefNo(jsonData?.dmemo_reference_no);
                }

                if(jsonData?.dmemo_pre_emi_end_date !==''){                    
                    
                    setLessPreEmiTill5thLabel(`Pre-EMI Till 5TH ${formatOnlyMonthYearValue(jsonData?.dmemo_pre_emi_end_date)} ${jsonData?.dmemo_pre_emi_type !== '' ? ` (${jsonData?.dmemo_pre_emi_type})` : ''}`);
                }
                
                if (jsonData?.coapplicantGuarantorDetails) {
                 setCoapplicantGuarantorRows(jsonData.coapplicantGuarantorDetails);
                 // setAddedLeadCoapplicantGuarantorRows                  
                } 

                console.log("savedSanctionDetailsInfo = ", savedSanctionDetailsInfo); 
                 if(savedSanctionDetailsInfo?.id === undefined) { 
                    // for null
                    setExShowroomPriceValue(jsonData?.dmemo_invoice_price_per_vehicle);
                    setInsuranceAmounByDealerValue(jsonData?.assets_insurance_by_dealer);  
                    setTotalOnRoadPriceValue(jsonData?.dmemo_total_cost_per_vehicle);
                    
                    setLoanAmountValue(jsonData?.dmemo_funding_per_vehicle); 
                    setProcessingFeeOnFinanceAmountPlusGSTValue(jsonData?.dmemo_processing_fee_on_finance_amount_plus_gst);
                    setLessProcessingFeeIncludingGSTValue(jsonData?.dmemo_processing_fee_including_gst);
                    setLessInsuranceByKotakMahindraValue(jsonData?.cam_kotak_li_amount);
                    setLessPreEmiTill5THJanValue(jsonData?.dmemo_less_pre_emi_till_5th_jan);
                    setFileChargeValue(jsonData?.cam_file_charges);
                    setNetDisbursementValue(jsonData?.dmemo_net_disbursement);
                    setNameOfSupplierDealerValue(jsonData?.cam_dealer_name);

                    setAssetValueVehicleVehiclesValue(jsonData?.dmemo_invoice_price_all_vehicle);
                    setNoOfAssetValue(jsonData?.dmemo_no_of_asset);

                    setTotalDownPaymentByCustomerValue(jsonData?.dmemo_total_down_payment_by_customer);
                    
                } 
                
                
                const processingFeeIncludingGst = Number(jsonData?.dmemo_processing_fee_including_gst) || 0;
                const processingFeeExcludingGSTAmt = (Number(processingFeeIncludingGst) - Number(amountOfProcessingFee)).toFixed(2);
                setLessProcessingFeeExcludingGST(processingFeeExcludingGSTAmt);


                const payableTotheRE = Number(processingFeeExcludingGSTAmt) + Number(fileChargeExcludingGst); 
                setPayableTotheREAmount(payableTotheRE); 
 
                const cLIAmount =  Number(jsonData?.dmemo_kli_amount) || 0;
                const payableToThirdPartytheRE = Number(fileGstAmount) + Number(amountOfProcessingFee) + Number(cLIAmount); 
 
                setPayableToThirdPartyRoutedThroughRE(payableToThirdPartytheRE);

                const totalFeeChargesPayableAmount = Number(payableTotheRE) + Number(payableToThirdPartytheRE) ; 
                setTotalFeeChargesPayable(totalFeeChargesPayableAmount); 

                const sanctionAmt = jsonData?.dmemo_funding_per_vehicle || 0;
                const processingFeePer = jsonData?.dmemo_processing_fee_on_finance_amount_plus_gst || 0;
                
                const feeChargesPayableAmt = roundNumber((Number(sanctionAmt) * Number(processingFeePer) / 100)).toFixed(2);  
                setFeeChargesPayable(feeChargesPayableAmt);

                 let totalMarginMoneyReceiptAmtount = Number(jsonData?.irr_total_asset_price) || 0; 
               
                let totalMarginMoneyReceiptRequired = 0;
                if (jsonData?.dmemo_margin_money_all_vehicle !== '') {
                    totalMarginMoneyReceiptAmtount -= Number(jsonData?.dmemo_margin_money_all_vehicle) || 0;
                    totalMarginMoneyReceiptRequired += Number(jsonData?.dmemo_margin_money_all_vehicle) || 0;
                }
                if (processingFeeExcludingGSTAmt !== '') {
                    totalMarginMoneyReceiptAmtount -= Number(processingFeeExcludingGSTAmt) || 0;
                    totalMarginMoneyReceiptRequired += Number(processingFeeExcludingGSTAmt) || 0;
                }
                if (amountOfProcessingFee !== '') {
                    totalMarginMoneyReceiptAmtount -= Number(amountOfProcessingFee) || 0;
                     totalMarginMoneyReceiptRequired += Number(amountOfProcessingFee) || 0;
                }
                if (dearlerSubventionDedcuteAmount !== '') {
                    totalMarginMoneyReceiptAmtount -= Number(dearlerSubventionDedcuteAmount) || 0;
                     totalMarginMoneyReceiptRequired += Number(dearlerSubventionDedcuteAmount) || 0;
                }

                if (jsonData?.dmemo_pre_emi !== '') {
                    totalMarginMoneyReceiptAmtount -= Number(jsonData?.dmemo_pre_emi) || 0;
                    totalMarginMoneyReceiptRequired += Number(jsonData?.dmemo_pre_emi) || 0;
                }
                if (jsonData?.dmemo_file_charge !== '') {
                    totalMarginMoneyReceiptAmtount -= Number(jsonData?.dmemo_file_charge) || 0;
                    totalMarginMoneyReceiptRequired += Number(jsonData?.dmemo_file_charge) || 0;
                }
                if (jsonData?.dmemo_kli_amount !== '') {
                    totalMarginMoneyReceiptAmtount -= Number(jsonData?.dmemo_kli_amount) || 0;
                    totalMarginMoneyReceiptRequired += Number(jsonData?.dmemo_kli_amount) || 0;
                }
 
               

                setTotalMarginMoneyReceiptAmt(totalMarginMoneyReceiptRequired.toFixed(2));
               // setNetDisbursementAmt(totalMarginMoneyReceiptAmtount.toFixed(2));

                setNetDisbursementAmt((Number(jsonData?.dmemo_disbursement_amount_for_vehicle_including_box) || 0).toFixed(2));
               
                 setEmiAllVehicle((Number(jsonData?.dmemo_emi_all_vehicle) || 0).toFixed(2));
                 setSLTenure(Number(jsonData?.dmemo_tenure) || 0);

                setIsReadyToModify(resultArr[0]?._isReadyToModify);
                
                setLoanAmountSchedule(jsonData?.dmemo_funding_per_vehicle);
                setInterestRateSchedule(jsonData?.dmemo_irr); 
                setLoanDurationSchedule(sLTenure);
                setPaymentsPerYearSchedule(Number(jsonData?.dmemo_tenure) || 0);     
            }
    
            const crifDetailsMaster = resultArr[0]?.additional_info?.crif_details || [];
            setCrifDetails(crifDetailsMaster);
    
            const bankDetailsMaster = resultArr[0]?.additional_info?.banking_details || [];
            setBankDetails(bankDetailsMaster);
    
            const camApprovalHistoryInfo = resultArr[0]?.additional_info?.cam_approval_history || [];
            setCamApprovalHistory(camApprovalHistoryInfo);  
    
            const anchorCategoryMaster = resultArr[0]?.additional_info?.anchor_category_master || [];
            setAnchorCategories(anchorCategoryMaster);
    
            const speciallyAbledMaster = resultArr[0]?.additional_info?.specially_abled || [];
            setSpeciallyAbledArr(speciallyAbledMaster);
    
            const residenceTypesMaster = resultArr[0]?.additional_info?.residence_types || [];
            setResidenceTypesArr(residenceTypesMaster);
    
            const bankingUpiMaster = resultArr[0]?.additional_info?.banking_upis || [];
            setBankingUpiArr(bankingUpiMaster);
    
            const constitutionMaster = resultArr[0]?.additional_info?.constitutions || [];
            setConstitutionArr(constitutionMaster);
    
            const customerTypeMaster = resultArr[0]?.additional_info?.customer_type || [];
            setCustomerTypeArr(customerTypeMaster);
    
            const vehicleMakerMaster = resultArr[0]?.additional_info?.vehicle_maker || [];
            setVehicleMakerArr(vehicleMakerMaster);
    
            const vehicleUseMaster = resultArr[0]?.additional_info?.vehicle_use || [];
            setVehicleUseArr(vehicleUseMaster);
    
            const insuranceMaster = resultArr[0]?.additional_info?.insurance || [];
            setInsuranceArr(insuranceMaster);
    
            const vehicleModelsMaster = resultArr[0]?.additional_info?.vehicle_models || [];
            setVehicleModelsArr(vehicleModelsMaster);
    
            const businessValidationProofMaster = resultArr[0]?.additional_info?.business_validation_proof || [];
            setBusinessValidationProofArr(businessValidationProofMaster);
    
            const turnoverIncomeMaster = resultArr[0]?.additional_info?.turnover_income || [];
            setTurnoverIncomeArr(turnoverIncomeMaster);
    
            const workingCapitalCycleMaster = resultArr[0]?.additional_info?.working_capital_cycle || [];
            setWorkingCapitalCycleArr(workingCapitalCycleMaster);
    
            const accountTypeMaster = resultArr[0]?.additional_info?.account_type_master || [];
            setAccountTypeArr(accountTypeMaster);
             
          } 
        } catch (error) {
         // console.error("Error in getCAMDetailsData:", error);
        }
      };

    const getUploadLeadDocumentData = async () => {
        if (id !== undefined) {
            setPropLeadId(atob(id));
            setLeadId(propLeadId);

            const obj = { 'start': '0', 'length': config.MAX_RECORDS, "lead_id": atob(id), 'api_calling_module' : "sanction_module" };
            // console.log("obj lead id- ", obj);
            const requestData = encryptData(obj);
            const response = actions.getUploadLeadDocument(requestData);

            response.then((result) => {
                // console.log("Promise resolved -  source data:", result); 
                if (result.data.success === 1) {
                    const results = result.data.data.data;
                    const resultArr = Object.keys(results).map((key) => results[key]);
                    setAllUploadLeadDocument(resultArr);
                }
            }).catch((error) => {
                //  console.error("Promise rejected -  source data :", error); 
            });
        }
    };

    useEffect(() => {
        if (isActive) { 
           
            getSanctionConfigData();
            getUploadLeadDocumentData();
           
           
        }
    }, [isActive]);

    /* useEffect(() => {
         if (id !== undefined) {
             getUploadLeadDocumentData(); 
         }
 
     }, [setAllUploadLeadDocument]); */

    useEffect(() => {
        const obj = { 'start': '0', 'length': config.MAX_RECORDS };
        const requestData = encryptData(obj);
        const response = actions.masterDocumentTypeData(requestData, false);
        response.then((result) => {
            // console.log("Promise resolved -  source data:", result); 
            if (result.data.success === 1) {
                const results = result.data.data.data
                const filteredResultArr = results.filter((item) => item.status === "1");
                const sortedResultArr = filteredResultArr.sort((a, b) =>
                    a.document_type.localeCompare(b.document_type)
                );
                setAllDocumentTypeData(sortedResultArr);
            }
        }).catch((error) => {
            //  console.error("Promise rejected -  source data :", error); 
        });

    }, [setAllDocumentTypeData]);

    const handleDocumentFileChange = (e) => {
        const files = Array.from(e.target.files);
        const base64Files = [];

        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = (event) => {
                const base64Data = event.target.result;
                const fileName = file.name;
                base64Files.push({ file: base64Data, name: fileName });
                if (base64Files.length === files.length) {
                    setSelectedDocumentFiles(base64Files);
                }
            };
            reader.readAsDataURL(file);
        });
    };

    const onSubmit = (data) => {

        setPropLeadId(atob(id));
        setLeadId(propLeadId);

        if (data.document_type.trim() === "") {
            toast.error("No document type has been selected.", {
                position: "top-right",
            });
        } else if (!selectedDocumentFiles || selectedDocumentFiles.length === 0) {
            toast.error("No file has been selected.", {
                position: "top-right",
            });
        } else if (data.document_note.trim() === "") {
            toast.error("Note is blank.", {
                position: "top-right",
            });
        } else {

            const params = { "lead_id": propLeadId, "document_type": data.document_type, "document_note": data.document_note, "document_file": selectedDocumentFiles };

            const requestData = encryptData(params);
            const response = actions.addEditLeadDocument(requestData, navigate);

            response.then((result) => {
                // console.log("Promise resolved - addEditLeadDocument form:", result); 
                if (result.data.success === 1) {
                    toast.success(result.data.message, {
                        position: "top-right",
                    });

                    const obj = { 'start': '0', 'length': config.MAX_RECORDS, "lead_id": propLeadId };
                    // console.log("obj lead id- ", obj);
                    const requestData = encryptData(obj);
                    const response = actions.getUploadLeadDocument(requestData);

                    response.then((result) => {
                        // console.log("Promise resolved -  source data:", result); 
                        if (result.data.success === 1) {
                            const results = result.data.data.data;
                            const resultArr = Object.keys(results).map((key) => results[key]);
                            setAllUploadLeadDocument(resultArr);
                        }
                    }).catch((error) => {
                        //  console.error("Promise rejected -  source data :", error); 
                    });

                    reset();
                    setSelectedDocumentFiles("");
                    props.updateParentState(false);
                } else {
                    toast.error(result.data.message, {
                        position: "top-right",
                    });
                }
            }).catch((error) => {
                toast.error(error, {
                    position: "top-right",
                });
            });
        }
    };

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };

    const filteredItems = (allUploadLeadDocument ?? []).filter(item =>
        item.formatetdID.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.assignedUser.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.statusName.toLowerCase().includes(searchQuery.toLowerCase())
    );


    const startIndex = (currentPage - 1) * config.ITEMS_PER_PAGE;
    const endIndex = startIndex + config.ITEMS_PER_PAGE;
    const paginatedItems = filteredItems.slice(startIndex, endIndex);
    const totalPages = Math.ceil(filteredItems.length / config.ITEMS_PER_PAGE);

    const onRowClickAction = (itemObj, btnAction) => {
        setViewModalInfo(itemObj);
        setOpen(true);
    }

    const veridateDoc = (data, actionStatus) => {

        const verifyDocStatus = (actionStatus) ? 1 : 0;
        const params = { "id": data.id, "status": verifyDocStatus };

        const requestData = encryptData(params);
        const response = actions.verifyDocuments(requestData);
        response.then((result) => {
            if (result.data.success === 1) {
                toast.success(result.data.message, {
                    position: "top-right",
                });
                getUploadLeadDocumentData();
            } else {
                toast.error(result.data.message, {
                    position: "top-right",
                });
            }
        }).catch((error) => {
            toast.error(error, {
                position: "top-right",
            });
        });
    };

    const handleNoBank = (event, item) => {
        setIsVerifyDocChecked(event.target.checked)
        veridateDoc(item, event.target.checked);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleToggle = (action='') =>{ 

         if(action !==''){
            setSanctionFormActiveTab(action);
            setSanctionFormStatus(true);
        }else{
             setSanctionFormStatus(prevStatus => !prevStatus); 
        }
        
        getSanctionConfigData();
    }

    const handleToggleUpdateDetails = () =>{
        setEnableUpdatePdfDetails(prevState => !prevState); 
    }

    const handleToggleSaveDetails = () =>{ 
        getSanctionConfigData();
    }

    const handleSourceDealerChange = (event) =>{
          setSourceDealerDetails(event.target.value);
    }

    const handleFormChange = (event) =>{
        if(event.target.name ==='refNo'){
             setRefNo(event.target.value);
        }
        if(event.target.name ==='insuranceFor'){
            setInsuranceFor(event.target.value); 
            if(event.target.value === ''){
                setInsuranceFor('For insurance by ckers');
            } 
         }
        if(event.target.name ==='dealerSubvention'){
            setDealerSubvention(event.target.value);
            if(event.target.value === ''){
                setDealerSubvention('Dealer Subvention');
            }
        }

        if(event.target.name ==='loanAmountValue'){
            setLoanAmountValue(event.target.value); 
        }

        if(event.target.name ==='processingFeeOnFinanceAmountPlusGSTValue'){
            setProcessingFeeOnFinanceAmountPlusGSTValue(event.target.value); 
        }

        if(event.target.name ==='lessProcessingFeeIncludingGSTValue'){
            setLessProcessingFeeIncludingGSTValue(event.target.value); 
        }

        if(event.target.name ==='lessInsuranceByKotakMahindraValue'){
            setLessInsuranceByKotakMahindraValue(event.target.value); 
        }

        if(event.target.name ==='lessPreEmiTill5THJanValue'){
            setLessPreEmiTill5THJanValue(event.target.value); 
        }

        if(event.target.name ==='fileChargeValue'){
            setFileChargeValue(event.target.value); 
        }

        if(event.target.name ==='netDisbursementValue'){
            setNetDisbursementValue(event.target.value); 
        }

        if(event.target.name ==='nameOfSupplierDealerValue'){
            setNameOfSupplierDealerValue(event.target.value); 
        }

        if(event.target.name ==='exShowroomPriceValue'){
            setExShowroomPriceValue(event.target.value); 
        }

        if(event.target.name ==='assetValueVehicleVehiclesValue'){
            setAssetValueVehicleVehiclesValue(event.target.value); 
        }

        if(event.target.name ==='noOfAssetValue'){
            setNoOfAssetValue(event.target.value); 
        }

        if(event.target.name ==='insuranceAmounByDealerValue'){
            setInsuranceAmounByDealerValue(event.target.value); 
        }

        if(event.target.name ==='totalOnRoadPriceValue'){
            setTotalOnRoadPriceValue(event.target.value); 
        }
 
 
        if(event.target.name ==='insuranceForValue'){
            setInsuranceForValue(event.target.value); 
        }

        if(event.target.name ==='dealerSubventionValue'){
            setDealerSubventionValue(event.target.value); 
        }
         
         
    }

    const [htmlContent, setHtmlContent] = useState('');
    const editorRef = useRef(null);
    

    const handleInput = () => {
        setHtmlContent(editorRef.current.innerHTML);
    };

    const [formRejectitem, setFormRejectitem] = useState({
      notes: '',
    });

    const btnOpenRejectData = (approveBtnAction,sendEmail='0') => {    // buttonFun 
        setApproveBtnAction(approveBtnAction);
        setOpenRejectAmt(true);
        setSendEmailBtnAction(sendEmail);
    };

    const handleCloseRejectAmt = () => {     // Modal onclick closedFun
        setApproveBtnAction(0);
        setOpenRejectAmt(false);
        setSendEmailBtnAction(0);
       };

       const handleRejectFormSubmit = (data) => {
         if (data.notes === '') {
           toast.error("Notes is required.", {
             position: "top-right",
           });
         } else { 
           
              if(approveBtnAction === '1'){
                 getSanctionConfigData('approve',data.notes);
             }
             
             if(approveBtnAction === '2'){
                 getSanctionConfigData('reject',data.notes);
             }

             if(approveBtnAction === '3'){
                getSanctionConfigData('reversal',data.notes);
            }
         }
        }

        const handleAmtRejectChange = (e) => {
            const totalAmt = e.target.value;
            setFormRejectitem((prevState) => ({
              ...prevState,
              totalAmt,
            }));
          }

        const printRef = useRef();
        const handleDownloadPdf = async (copyType) => {

        setDownloadPdfType(copyType);

        // download copy after 2 sconds
        const timer = setTimeout(async () => {
          
            const element = printRef.current;

            if (!element) {
                console.error('Element not found');
                return;
            }

            const canvas = await html2canvas(element, {
                scale: 2, // Improve quality
                useCORS: true,
            });

            const imgData = canvas.toDataURL('image/png');
            const pdf = new JsPDF('p', 'mm', 'a4');

            
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();

            const imgWidth = pdfWidth;
            const imgHeight = (canvas.height * pdfWidth) / canvas.width;

            let position = 0;

            if (imgHeight < pdfHeight) {
                // Single page
                pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
            } else {
                // Multi-page
                let heightLeft = imgHeight;

                while (heightLeft > 0) {
                pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
                heightLeft -= pdfHeight;
                position -= pdfHeight;

                if (heightLeft > 0) {
                    pdf.addPage();
                }
                }
            }

            const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
            let filename = `sanction_letter_${timestamp}.pdf`;
            if (sanctionFormActiveTab === 'kfs') {
                filename = `kfs_${timestamp}.pdf`;
            }

            pdf.save(filename);
        }, 2000);
};


    const toggleSection = (tabName) => {

      //  alert(tabName);

        if (tabName === 'FI') {
            setIsFIOpen(!isFIOpen);
        }

        if (tabName === 'Miscellaneous Documents') {
            setIsMiscOpen(!isMiscOpen);
        }

        if (tabName === 'Applicant Documents') {
            setIsApplicantOpen(!isApplicantOpen);
        }

        if (tabName === 'Co-Applicant Documents') {
            setIsCoApplicantOpen(!isCoApplicantOpen);
        }

        if (tabName === 'Guarantor Documents') {
            setIsGuarantorOpen(!isGuarantorOpen);
        }
    };

   

    return (
        <>
<div id="main-wrap" className='mt-4'>
<div className='row justify-content-between'>
<h5 className="fw-bold">Sanction Letter</h5>

{(userRoleType === "Credit" || userRoleType === "Manager" || userRoleType === "Super Admin" || userRoleType === 'Superadmin' || userRoleType === 'Credit Head' || userRoleType === 'Credit Operations') ? (
<div className="col-md-12 mb-3">

     {sanctionFormStatus && (
        <>
        <button type="button" className={
                      sanctionFormActiveTab !== "kfs" 
                        ? "btn btn-success text-white"
                        : "btn btn-default text-white"
                    } onClick={() => handleToggle('sanction_letter')}  title="Visible To : Credit , Manager , Credit Head and Superadmin Users" >
         Sanction Letter
         </button>  
        &nbsp; <button type="button" className={
                      sanctionFormActiveTab === "kfs" 
                        ? "btn btn-success text-white"
                        : "btn btn-default text-white"
                    } onClick={() => handleToggle('kfs')} 
         title="Visible To : Credit , Manager , Credit Head and Superadmin Users" >
         KFS
         </button>&nbsp;&nbsp;
        </>
    )}

    <button type="button" className="btn btn-primary text-white" onClick={() => handleToggle('')}  title="Visible To : Credit , Manager , Credit Head and Superadmin Users" >
    {sanctionFormStatus ? 'Go Back' : 'Show Sanction Letter'}
    </button>
 

    {(  (userRoleType === "Credit" ||  userRoleType === "Super Admin" || userRoleType === 'Superadmin') ) && (
     <button type="button" className="btn btn-warning text-white float-right" onClick={clickCcmTab} title="Visible To : Credit and Superadmin Users" >
      { isReadyToModify ? "Update Sanction Terms Details" : "Sanction Terms Details" }
    </button>
    )} 

    
</div> 
) : (
    <div className="col-md-12 mb-3">

    {sanctionFormStatus && (
        <>
        <button type="button" className={
                      sanctionFormActiveTab !== "kfs" 
                        ? "btn btn-success text-white"
                        : "btn btn-default text-white"
                    } onClick={() => handleToggle('sanction_letter')}  title="Visible To : Credit , Manager , Credit Head and Superadmin Users" >
         Sanction Letter
         </button>  
        &nbsp; <button type="button" className={
                      sanctionFormActiveTab === "kfs" 
                        ? "btn btn-success text-white"
                        : "btn btn-default text-white"
                    } onClick={() => handleToggle('kfs')} 
         title="Visible To : Credit , Manager , Credit Head and Superadmin Users" >
         KFS
         </button>&nbsp;&nbsp;
        </>
    )}
    <button type="button" className="btn btn-primary text-white" onClick={() => handleToggle('')}   title="Visible To : Credit , Manager , Credit Head and Superadmin, Users" >
    {sanctionFormStatus ? 'Go Back' : 'Show Sanction Letter'} 
    </button>
    </div> 
)} 

<div className=""> 

{ ( !sanctionFormStatus) ?(<>
<div className='row'>
{activeAccordionSections.map((sectionInfo, sectionIndex) => {
    const matchingDocs = activeAllSancationDocs.filter(
        (doc) => doc.doc_section === sectionInfo
    );
    let isOpenSection = false;
    if (sectionInfo === 'Miscellaneous Documents') {        
        isOpenSection = isMiscOpen;
    }

    if (sectionInfo === 'Applicant Documents') {
         isOpenSection = isApplicantOpen;
    }

    if (sectionInfo === 'Co-Applicant Documents') {
         isOpenSection = isCoApplicantOpen;
    }

    if (sectionInfo === 'Guarantor Documents') {
         isOpenSection = isGuarantorOpen;
    }

    return (
        <div key={sectionIndex} className="col-md-12">
            <div className="collapsible-section">

                <button
                    className="section-header"
                    onClick={() => toggleSection(sectionInfo)}
                >
                    <h5>{sectionInfo}</h5>
                    <span>{isFIOpen ? '-' : '+'}</span>
                </button> 
                {isOpenSection && (
                    <div className="section-content">
                        {matchingDocs.map((docInfo, index) => {
                            // Find the matching document in allUploadLeadDocument
                            const matchedDoc = allUploadLeadDocument.find((item) => item.documentTypeName === docInfo.doc_name);

                            return (
                                <div key={index} className="col-md-12 mb-2">

                                    <b>{docInfo.doc_name}</b>
                                    {matchedDoc ? (
                                        <>
                                           
                                            { (matchedDoc.document !=='') && (
                                             <>   
                                            &nbsp; -  &nbsp;
                                            <a target="new" href={matchedDoc.document} className="text-decoration-none">
                                                Download File
                                            </a>
                                            &nbsp; Uploaded On {matchedDoc.created_date} by {matchedDoc.createdByName}
                                            </>
                                            ) }

                                            {matchedDoc.verified_status !== "1" ? (
                                                <>
                                                    &nbsp;- <span className="text-danger">NOT VERIFIED</span>
                                                </>
                                            ) : (

                                                <>
                                                    &nbsp; - <span className='text-green'>Validated On</span> {matchedDoc.validated_date} by {matchedDoc.validatedByName}
                                                </>
                                            )}


                                            {(userRoleType === "Credit" || userRoleType === "Manager" || userRoleType === "Super Admin" || userRoleType === 'Superadmin') && (
                                                <>
                                                    {(matchedDoc.documentTypeStatus === 'dynamic') ?
                                                        (
                                                            <>
                                                                <span className='float-right'>
                                                                    {matchedDoc.verified_status !== '1' ? (
                                                                        <>
                                                                            {(matchedDoc.notMatchingDetails !== '') ? JSON.parse(matchedDoc.notMatchingDetails) : ''}
                                                                        </>
                                                                    ) : (
                                                                        <>&nbsp;</>
                                                                    )}
                                                                </span>
                                                            </>
                                                        ) : (
                                                            <>
                                                                {matchedDoc.verified_status !== '1' ? (
                                                                    <span className='float-right'>
                                                                        <input type='checkbox' name='document_verify' id='document_verify'
                                                                            {...register('document_verify')}
                                                                            onChange={(event) => handleNoBank(event, matchedDoc)}
                                                                        /> <b>Verify</b></span>
                                                                ) : (
                                                                    <>&nbsp;</>
                                                                )}
                                                            </>
                                                        )}


                                                </>
                                            )}

                                        </>
                                    ) : (
                                        <>
                                            &nbsp;- <span className="text-danger">NOT UPLOADED</span>
                                        </>
                                    )}

                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
})} 

<div className="col-md-12">
    <div className="collapsible-section">
        <button
            className="section-header"
            onClick={() => toggleSection('FI')}
        >
            <h5>FI Details</h5>
            <span>{isFIOpen ? '-' : '+'}</span>
        </button>

        {isFIOpen && (
            <div className="section-content">
                {allLeadCheckLists.map((item, index) => (
                    <div key={index} className="col-md-12 mb-2">

                        <b>{item.check_list_name}</b> {(item.section_name !== '') && (<> (<span
                            className={
                                item.section_name === 'Lead'
                                    ? 'text-green'
                                    : item.section_name === 'Guarantor'
                                        ? 'text-primary'
                                        : 'text-warning'
                            }
                        >{(item.section_name === 'Lead') ? "Applicant" : item.section_name}</span> - {item.checklist_user_name})</>)}

                        {(item.fieldInvestigationFalg === '1') ? (
                            <>
                                &nbsp; - Verified by system
                            </>
                        ) : (
                            <>
                                &nbsp;- <span className="text-danger">NOT VERIFIED</span>
                            </>
                        )}

                        {item.section_name !== "Lead" && (
                            <>
                            {item.checklist_user_status === "1" ? (
                                <span className="text-success"> - Active</span>
                            ) : (
                                <span className="text-danger"> - Inactive</span>
                            )}
                            </>
                        )}

                    </div>
                ))}
            </div>)}
    </div>
</div>
</div>
</>) :

(
 <>
     <div>
        
      <div ref={printRef}>
         <div style={
                isReadyToModify
                ? { border: "1px solid grey", padding: "10px" }
                : { border: "1px solid grey", padding: "10px", background: "#dbfed4" }
            }>

                    
            <div style={{ textAlign: "center"}}>
            {(camDetails?.cam_lender ==='Vivriti') ? (
                    <>
                    <div style={{display:"flex",alignItems:"center",justifyContent:"center",position: "relative"}}>  
                        <div className={ sanctionFormActiveTab !== "kfs" ? "" : "d-none"} style={{position:"absolute",left: "0",textAlign: "left"}}>
                            Date : {formatDateForValue(camDetails?.dmemo_date)}<br/>
                            City : {leadCity}<br/> 
                        </div> 
                        <img src="/assets/vivriti-logo.png" className="login-logo-" alt="Vivriti Logo" style={{display:"block",margin:"0 auto"}} />
                        </div>

                        
                        <h4> Vivriti Capital Limited</h4>
                        Prestige Zackria Metropolitan, No. 200/1-8, 2nd Floor, Block 1, Anna Salai, Chennai - 600002
                    </>
                 ) : (
                    <>
                   

                <div style={{display:"flex",alignItems:"center",justifyContent:"center",position: "relative"}}>  
                <div className={ sanctionFormActiveTab !== "kfs" ? "" : "d-none"} style={{position:"absolute",left: "0",textAlign: "left"}}>
                    Date : {formatDateForValue(camDetails?.dmemo_date)}<br/>
                    City : {leadCity}<br/> 
                </div> 
                <img src="/assets/ckern-logo.png" className="login-logo-" alt="CKers Logo" style={{display:"block",margin:"0 auto"}} />
                </div>
                <h4> cKers Finance Private Limited</h4>
                Building No-24-30, First Floor, Okhla Industrial Area Phase - III, New Delhi 110020, India
                 </>
                 )}
                 </div>

            <div style={{ textAlign: "center"}}>
                <div style={{ paddingTop: '10px' }}>
                 <h5>{ sanctionFormActiveTab !== "kfs" ? "In Principle Sanction Letter" : ""}&nbsp;</h5>
                </div>
            </div>

            { /* Sanction Letter section  :  START HERE */ }
            <div className={ sanctionFormActiveTab !== "kfs" ? "" : "d-none"}> 

                  {/*  Date : {formatDateForValue(camDetails?.dmemo_date)}<br/>
                    City : {leadCity}<br/><br/> */}
                    Name Of Customer :  {(camDetails?.dmemo_customer_name !=='') ? camDetails?.dmemo_customer_name : leadName}<br/>
                    Residential Address :  {leadAddress}<br/>
                    Ref No : { ( enableUpdatePdfDetails) ? (
                            <>
                             <input  
                                id="refNo" name="refNo" 
                                style={{ width: 'auto' }}
                                className='form-control' {...register('refNo')} 
                                value={refNo} 
                                onChange={handleFormChange} 
                             /> 
                            </>
                        ) : (
                            <>
                             {refNo} 
                            </>
                        )}<br/><br/>
                    Dear {(camDetails?.dmemo_customer_name !=='') ? camDetails?.dmemo_customer_name : leadName},  <br/><br/>
                    <div>
                     We are pleased to inform you that we have approved your Electric Commercial Vehicle Loan with reference to your loan application.
                    </div>
                   
                    <table style={{ border: '1px',width:'100%' }}>
                        <tr> 
                            <th style={{ borderWidth: '1px' }}>Model</th>
                            <th style={{ borderWidth: '1px' }}>Asset Value (Vehicle)</th>
                            <th style={{ borderWidth: '1px' }}>No of Vehicle</th>
                            <th style={{ borderWidth: '1px' }}>Tenure</th>
                            <th style={{ borderWidth: '1px' }}>IRR(Flat)</th>
                            <th style={{ borderWidth: '1px' }}>IRR(Reducing)</th>
                            <th style={{ borderWidth: '1px' }}>1st EMI (Interest+Principle)Start Date</th>
                            <th style={{ borderWidth: '1px' }}>Tentative EMI</th>
                            <th style={{ borderWidth: '1px' }}>Total down payment by Customer(Including PF and Other Charges)</th>
                        </tr>

                        <tr> 
                            <td style={{ borderWidth: '1px' }}>{camDetails?.dmemo_vehicle_models}</td>
                            
                            <td style={{ borderWidth: '1px' }} title={`Old value - ${camDetails?.dmemo_total_cost_per_vehicle}`}>{camDetails?.dmemo_total_cost_per_vehicle}</td>

                            <td style={{ borderWidth: '1px' }} title={`Old value - ${camDetails?.dmemo_no_of_asset}`}>{camDetails?.dmemo_no_of_asset}</td>


                            <td style={{ borderWidth: '1px' }}>{sLTenure}</td>
                            <td style={{ borderWidth: '1px' }}>{camDetails?.dmemo_flat_rate}</td>
                            <td style={{ borderWidth: '1px' }}>{camDetails?.dmemo_irr}</td>
                            <td style={{ borderWidth: '1px' }}>{formatDateForValue(camDetails?.dmemo_first_emi_interest_date)}</td>
                            
                            <td style={{ borderWidth: '1px' }}>{camDetails?.dmemo_emi_per_vehicle}</td>

                            <td style={{ borderWidth: '1px' }} title={`Old value - ${camDetails?.dmemo_total_down_payment_by_customer}`}>{camDetails?.dmemo_total_down_payment_by_customer}</td>
                        </tr>
                    </table>

                    <div style={{ clear: 'both' }}>&nbsp;</div>
                    <table style={{ border: '1px',width:'100%' }}>
                        <tr> 
                            <th style={{ borderWidth: '1px' }}>Ex Showroom Price</th>
                            <th style={{ borderWidth: '1px' }}>Registration Charges (Rs)</th>
                            <th style={{ borderWidth: '1px' }}>Fabrication</th>
                            <th style={{ borderWidth: '1px' }}>Discount</th>
                            <th style={{ borderWidth: '1px' }}>AMC</th>
                            <th style={{ borderWidth: '1px' }}>Insurance by Dealer</th>
                            <th style={{ borderWidth: '1px' }}>Insurance by cKers</th>
                            <th style={{ borderWidth: '1px' }}>Total On Road Price</th>
                        </tr>
                       
                        <tr> 
                            <td style={{ borderWidth: '1px' }} title={`Old value - ${camDetails?.dmemo_invoice_price_per_vehicle}`}>{camDetails?.dmemo_invoice_price_per_vehicle} </td>
                            <td style={{ borderWidth: '1px' }}>{camDetails?.assets_registration_charges_including_gst}</td>
                            <td style={{ borderWidth: '1px' }}>{camDetails?.assets_febrication}</td>
                            <td style={{ borderWidth: '1px' }}>{camDetails?.assets_discount}</td>
                            <td style={{ borderWidth: '1px' }}>{camDetails?.assets_amc}</td>
                            
                            <td style={{ borderWidth: '1px' }} title={`Old value - ${camDetails?.assets_insurance_by_dealer}`}>{camDetails?.assets_insurance_by_dealer}</td>

                            <td style={{ borderWidth: '1px' }} title={`Old value - ${camDetails?.assets_insurance_by_customer_ckers}`}>{camDetails?.assets_insurance_by_customer_ckers}</td>

                            <td style={{ borderWidth: '1px' }} title={`Old value - ${camDetails?.dmemo_total_cost_per_vehicle}`}> {camDetails?.dmemo_total_cost_per_vehicle}</td>
                        </tr>
                    </table>

                    <div style={{ clear: 'both' }}>
                     Your loan will be disbursed on receipt of following documents: <br/>
                        <ul>
                            <ol style={{ paddingLeft: '15px' }}>1. Stamped Loan Agreement </ol>
                            <ol style={{ paddingLeft: '15px' }}>2. Repayment Instructions (Post Dated cheques or Debit - ECS Instructions) </ol>
                            <ol style={{ paddingLeft: '15px' }}>3. Invoice and Insurance (Policy / Cover Note) with hypothication in favour of { (camDetails?.cam_lender ==='Vivriti') ? "Ckers Finance Private Limited" : "Ckers Finance Private Limited" } duly recorded thereon Marign Money Receipt </ol>
                            <ol style={{ paddingLeft: '15px' }}>4. Signed RTO Booklet</ol>
                        </ul>
                    </div> 


    
    <table style={{ border: '1px',width:'100%' }}>
        <tr> 
            <th style={{ borderWidth: '1px' }}>Loan Amount</th>
            <th style={{ borderWidth: '1px' }}>Processing Fee(%)</th>
            <th style={{ borderWidth: '1px' }}>Less:Processing Fee Including GST @18%</th>
            <th style={{ borderWidth: '1px' }}>Less: Credit Life Insurance </th>
            <th style={{ borderWidth: '1px' }}>{ (camDetails?.cam_lender ==='Vivriti') ? "" : "Less: " }{lessPreEmiTill5thLabel} </th>
            <th style={{ borderWidth: '1px' }}>FILE CHARGE</th>

             
            <th style={{ borderWidth: '1px' }}>Dealer Subvention</th>

            <th style={{ borderWidth: '1px' }}>Net Disbursement</th>
            <th style={{ borderWidth: '1px' }}>Name of Supplier /Dealer</th>
        </tr>

        <tr> 
            <td style={{ borderWidth: '1px' }} title={`Old value - ${camDetails?.dmemo_loan_amount}`}>{camDetails?.dmemo_loan_amount}</td>
           
            <td style={{ borderWidth: '1px' }} title={`Old value - ${camDetails?.dmemo_processing_fee_on_finance_amount_plus_gst}`}>{camDetails?.dmemo_processing_fee_on_finance_amount_plus_gst}%</td>
            
            <td style={{ borderWidth: '1px' }} title={`Old value - ${camDetails?.dmemo_processing_fee_including_gst}`}>{camDetails?.dmemo_processing_fee_including_gst}</td>
           
           <td style={{ borderWidth: '1px' }} title={`Old value - ${camDetails?.cam_kotak_li_amount}`}>{camDetails?.cam_kotak_li_amount}  {camDetails?.dmemo_kli_amount_type !=='' && (
                <>
                ({camDetails?.dmemo_kli_amount_type})
                </>
           ) }</td>

            <td style={{ borderWidth: '1px' }} title={`Old value - ${camDetails?.dmemo_pre_emi}`} >{camDetails?.dmemo_pre_emi}</td>
           
            <td style={{ borderWidth: '1px' }} title={`Old value - ${camDetails?.cam_file_charges}`} >{camDetails?.cam_file_charges}</td>

            
            <td style={{ borderWidth: '1px' }}>{camDetails?.dmemo_dealer_subvention}</td>

            <td style={{ borderWidth: '1px' }}  title={`Old value - ${camDetails?.dmemo_disbursement_amount_for_vehicle_including_box}`} >{camDetails?.dmemo_disbursement_amount_for_vehicle_including_box}</td>

            <td style={{ borderWidth: '1px' }} title={`Old value - ${camDetails?.cam_dealer_name}`} >{camDetails?.cam_dealer_name}</td>
        </tr>
    </table>
                    
                     
                    <div style={{ clear: 'both' }}>
                    You are requested to note as follows :<br/>  
                    
                    <ul>
                        <ol style={{ paddingLeft: '15px' }}>
                        1. The Sanction letter is valid for 15 days from the date of issue and subject to terms and conditions stated above. Any change in terms/condition would require a fresh sanction letter. </ol> 

                      { /*  <ol style={{ paddingLeft: '15px' }}>
                        2. Processing Fee and Pre-EMI will be require to be deposit with the dealer at the time of taking delivery </ol> */ }

                         <ol style={{ paddingLeft: '15px' }}>
                        2. If Pre-EMI is collect later then it needs to be deposit with { (camDetails?.cam_lender ==='Vivriti') ? "Vivriti Capital Limited" : "Ckers Finance Private Limited" }.</ol> 

                        <ol style={{ paddingLeft: '15px' }}>
                        3. Pre-EMI Interest will be calculated from the date of disbursement/delivery of the vehicle whichever is earlier to the start of first initial EMI{ /* & 
                        It will be deducted from disbursement which you need to deposit with the dealer */ }.</ol>  

                        <ol style={{ paddingLeft: '15px' }}>
                        4. It is assumed that you have inspected the vehicle and satisfied yourself of the quality thereof. { (camDetails?.cam_lender ==='Vivriti') ? "Vivriti Capital Limited" : "Ckers Finance Private Limited" } is not 
                        liable for any defect anddelivery or any other issue concerning the dealer and Regional Trasnport office / Insurance company/ 
                        or any other intermidary involved in this. </ol> 

                        <ol style={{ paddingLeft: '15px' }}>
                        5. The vehicle has to be register at the address mentioned above </ol> 

                        <ol style={{ paddingLeft: '15px' }}>
                        6. The amount of 1st EMI is subject to change as it will generate after the disbursement.</ol>  

                        <ol style={{ paddingLeft: '15px' }}>
                        7. Processing fee and other charges will be applicable as schedule of charges </ol> 

                        <ol style={{ paddingLeft: '15px' }}>
                        8. All cheques must be in favour of { (camDetails?.cam_lender ==='Vivriti') ? "Vivriti Capital Limited" : "Ckers Finance Private Limited" } Loan Account of Customer Name </ol> 

                        <ol style={{ paddingLeft: '15px' }}>
                        9. Please note that { (camDetails?.cam_lender ==='Vivriti') ? "Ckers Finance Private Limited" : "Ckers Finance Private Limited" } hypothecation should be properly mentioned in Invoice, Body Invoice, Margin Money Receipts, Insurance and Registration Certificate. Also provide copy of the Registration certificate within 30-40 days of delivery of vehicle. </ol> 

                        <ol style={{ paddingLeft: '15px' }}>
                        10. We accept insurance only with 0% deprication and Insured declared value of the vehicle should be 95% of the vehicle cost or should minimum cover our Finance Amount on the vehicle. </ol> 

                        <ol style={{ paddingLeft: '15px' }}>
                        11. This is in-principal sanction to the customer. This is not a delivery order. Please do not take delivery of the vehicle based on the sanction letter. All other formalities and loan documents are still pending to be execute. In case of any discrepancy found in the file or customer record or any other document which is relevant for { (camDetails?.cam_lender ==='Vivriti') ? "VCL" : "CFPL" } we can hold the payment or reject the file. </ol> 

                        { /* <ol style={{ paddingLeft: '15px' }}>
                        12. Last 6 month's updated banking to be submitted along with disbursal docs,if we find discrepancy into that sanctioned would be invalid.</ol> */ }
                    </ul>
                    </div> 
                     
                    <div style={{ clear: 'both' }}>
                        <h6>Subjectivity</h6>
                        { ( enableUpdatePdfDetails) ? (
                            <>
                             <textarea 
                                style={{height:'auto'}} 
                                 rows="5" 
                                id="source_dealer_details" name="source_dealer_details" 
                                className='form-control' {...register('source_dealer_details')} 
                                value={sourceDealerDetails} 
                                onChange={handleSourceDealerChange} 
                             /> 
                            </>
                        ) : (
                            <>
                            {sourceDealerDetails !== '' ?  ( 
                                <>
                                <div
                                  style={{ paddingLeft: '15px' }}
                                  dangerouslySetInnerHTML={{
                                    __html: sourceDealerDetails.replace(
                                      /\n/g,
                                      "<br />"
                                    ),
                                  }}
                                />
                              </>
                            ) : (
                                <>
                                <ul><li style={{ paddingLeft: '15px' }}>Complete and filled application form required. </li><li style={{ paddingLeft: '15px' }}>E-Nach activation confirmation required before disbursal. </li><li style={{ paddingLeft: '15px' }}>Down Payment proof required.</li><li style={{ paddingLeft: '15px' }}>All KYC self-attested and OSV done required. </li><li style={{ paddingLeft: '15px' }}>MSME certificate required. </li><li style={{ paddingLeft: '15px' }}>Zero Depreciation Insurance required before disbursal (Insurance IDV equal and more than loan amount. 1% deviation is acceptable due to market conditions).</li> <li style={{ paddingLeft: '15px' }}>Applicant clear KYC and Banking required with OSV before disbursal. </li> </ul>
                                </>
                                )
                            }
                            </>
                        )}
                    </div> 

                    <div style={{ clear: 'both',paddingTop: "1px" }}>&nbsp;</div>
                    <table style={{ width:'100%' }}>                        
                        <tr> 
                            <td>
                                Borrower Name <br/>
                                Signature <br/>
                                Date : {formatDateForValue(camDetails?.dmemo_date)}<br/>
                            </td>
                            <td>Maker Signature <br/>
                            {camDetails?.dmemo_maker_by}
                            </td>
                            <td>
                            { (camDetails?.cam_lender ==='Vivriti') ? "Vivriti Capital Limited" : "Ckers Finance Private Limited" } <br/>
                            Authorised Signature :  {camDetails?.dmemo_authorised_by}<br/>
                            Date : {formatDateForValue(camDetails?.dmemo_date)}<br/>
                            </td>                            
                        </tr>

                        <tr>
                        <td colSpan="3">
                            <hr />
                            {downloadPdfType === 'bank' ? (
                            <h2 style={{ textAlign: 'center' }}>Lender Copy</h2>
                            ) : (
                            <h2 style={{ textAlign: 'center' }}>Client Copy</h2>
                            )}
                        </td>
                        </tr>
                    </table>   
            </div>
            { /* Sanction Letter section  :  END HERE */ }               

            { /* KFS section  :  START HERE */ }            
            <div className={ sanctionFormActiveTab === "kfs" ? "" : "d-none"}> 
                       Loan Agreement No /Sanction Letter No : {refNo} <br/>
                       Date: {formatDateForValue(camDetails?.dmemo_date)}<br/> 
                       Borrower Name and Address : {(camDetails?.dmemo_customer_name !=='') ? camDetails?.dmemo_customer_name : leadName}<br/><br/>
                        
                 <div style={{ clear: 'both' }}>&nbsp;</div>
                    <table style={{ border: '1px',width:'100%' }}>
                        <tr> 
                            <th style={{ borderWidth: '1px',textAlign:'center', background: "rgba(145, 158, 171, 0.16)" }} colSpan="6"><h6>Key Fact Statement</h6></th>
                        </tr> 
                        <tr> 
                            <td style={{ borderWidth: '1px',textAlign:'center' }} colSpan="6"> Part 1 (Interest Rate and Fee/Charges)</td>
                        </tr>
                        <tr> 
                            <th style={{ borderWidth: '1px'}} colSpan="6">&nbsp;</th>
                        </tr>

                        <tr> 
                            <td style={{ borderWidth: '1px' }}>1</td>
                            <td style={{ borderWidth: '1px' }} ><b>Loan proposal/ account No.</b></td>
                            <td style={{ borderWidth: '1px' }}>{refNo}</td>
                            <td style={{ borderWidth: '1px' }} colSpan="2"><b>Type of Loan</b></td>
                            <td style={{ borderWidth: '1px' }}>Commercial Vehicle Loan- Secured</td>
                        </tr> 

                        <tr> 
                            <td style={{ borderWidth: '1px' }}>2</td>
                            <td style={{ borderWidth: '1px' }} colSpan="4"><b>Sanctioned Loan amount (in Rupees)</b></td>
                            <td style={{ borderWidth: '1px' ,textAlign:'center'  }} colSpan="1">{camDetails?.dmemo_funding_per_vehicle}</td> 
                        </tr> 

                        <tr> 
                            <td style={{ borderWidth: '1px' }}>3</td>
                            <td style={{ borderWidth: '1px' }} colSpan="4"><b>Disbursal schedule:</b><br/>
                                (i) Disbursement in stages or 100% upfront.<br/>

                                (ii) If it is stage wise, mention the clause of loan agreement having relevant details</td>
                            <td style={{ borderWidth: '1px' ,textAlign:'center'  }} colSpan="1">100% Upfront</td> 
                        </tr> 

                        <tr> 
                            <td style={{ borderWidth: '1px' }}>4</td>
                            <td style={{ borderWidth: '1px' }} colSpan="4"><b>Loan term (year/months/days)</b></td>
                            <td style={{ borderWidth: '1px' ,textAlign:'center'  }} colSpan="1">{sLTenure}  | Months </td> 
                        </tr> 

                        <tr> 
                            <td style={{ borderWidth: '1px' }}>5</td>
                            <td style={{ borderWidth: '1px' }} colSpan="4"><b>Instalment details</b></td>
                            <td style={{ borderWidth: '1px' ,textAlign:'center'  }} colSpan="1">&nbsp;</td> 
                        </tr> 

                        <tr> 
                            <td style={{ borderWidth: '1px', height:"50px" }}><b>Type of Installment</b></td>
                             <td style={{ borderWidth: '1px' }} colSpan="2"><b>Number of EPIs</b></td>
                            <td style={{ borderWidth: '1px' }} colSpan="2"><b>EPIs (In INR)</b></td>
                            <td style={{ borderWidth: '1px' }}><b>Commencement of repayment, post sanction</b></td>
                        </tr> 

                         <tr> 
                            <td style={{ borderWidth: '1px' }}>{sLTenure} Equated EMI</td>
                             <td style={{ borderWidth: '1px' }} colSpan="2">{sLTenure}</td>
                            <td style={{ borderWidth: '1px' }} colSpan="2">As Per Repayment Schedule To be sent with Welcome Letter</td>
                            <td style={{ borderWidth: '1px' }}>5th Of Every Month</td>
                        </tr> 

                        <tr> 
                            <td style={{ borderWidth: '1px' }}>6</td>
                            <td style={{ borderWidth: '1px' }} colSpan="4"><b>Interest rate (%) </b></td>
                            <td style={{ borderWidth: '1px' ,textAlign:'center'  }} colSpan="1">{camDetails?.dmemo_irr}</td> 
                        </tr> 

                         <tr> 
                            <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                            <td style={{ borderWidth: '1px' }} colSpan="4"><b> Interest type (fixed or floating or hybrid)</b></td>
                            <td style={{ borderWidth: '1px' ,textAlign:'center'  }} colSpan="1">Fixed</td> 
                        </tr> 

                        <tr> 
                            <td style={{ borderWidth: '1px' }}>7</td>
                            <td style={{ borderWidth: '1px' }} colSpan="5"><b>Additional Information in case of Floating rate of interest</b></td>
                             
                        </tr> 

                        <tr> 
                            <td style={{ borderWidth: '1px' }}><b>Reference Benchmark</b></td>
                            <td style={{ borderWidth: '1px' }}><b>Benchmark rate (%) (B)</b></td>
                            <td style={{ borderWidth: '1px' }}><b>Spread (%) (S)</b></td>
                            <td style={{ borderWidth: '1px' }}><b>Final rate (%)<br/>R = (B) + (S)</b></td>
                            <td style={{ borderWidth: '1px' }}><b>Reset periodicity (Months)</b></td>
                            <td style={{ borderWidth: '1px' }}><b>Impact of change in the reference benchmark</b></td>
                        </tr> 

                        <tr> 
                            <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                            <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                            <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                            <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                            <td style={{ borderWidth: '1px' }}><span >B&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;S</span></td>
                            <td style={{ borderWidth: '1px' }}><span >EPI (In INR)| No. of EPIs</span></td>
                        </tr> 

                         <tr> 
                            <td style={{ borderWidth: '1px',textAlign:'center' }} colSpan="6">  Not Applicable</td>
                        </tr>

                        <tr> 
                            <td style={{ borderWidth: '1px' }}>8</td>
                            <td style={{ borderWidth: '1px' }} colSpan="5"><b>Fee / Charges</b></td>
                         </tr> 

                         <tr> 
                            <td style={{ borderWidth: '1px' }} colSpan="2">&nbsp;</td>
                            <td style={{ borderWidth: '1px' }} colSpan="2"><b>Payable to the RE (A)</b></td>
                            <td style={{ borderWidth: '1px' }} colSpan="2"><b>Payable to a third party through RE (B)</b></td>
                         </tr>

                         <tr> 
                            <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                            <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                            <td style={{ borderWidth: '1px' }}>One-time/Recurring</td>
                            <td style={{ borderWidth: '1px' }}>Amount (in INR) or Percentage (%) as applicable</td>
                            <td style={{ borderWidth: '1px' }}>Onetime/Recurring</td>
                            <td style={{ borderWidth: '1px' }}><span >Amount (in ₹) or Percentage (%) as applicable</span></td>
                        </tr> 


                        <tr> 
                            <td style={{ borderWidth: '1px' }}>(i)</td>
                            <td style={{ borderWidth: '1px' }}>Processing Fees (Excluding GST)</td>
                            <td style={{ borderWidth: '1px' }}>One-time{ /* lessProcessingFeeExcludingGST */ }</td>
                            <td style={{ borderWidth: '1px' }}>{ /* (camDetails?.dmemo_processing_fee_on_finance_amount_plus_gst !=='') && (<>
                                 {camDetails?.dmemo_processing_fee_on_finance_amount_plus_gst}% </> 
                             ) */ }{  lessProcessingFeeExcludingGST }&nbsp;</td>
                            <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                            <td style={{ borderWidth: '1px' }}>{(Number(amountOfProcessingFee) || 0).toFixed(2)}&nbsp;</td>
                        </tr> 

                        <tr> 
                            <td style={{ borderWidth: '1px' }}>(ii)</td>
                            <td style={{ borderWidth: '1px' }}>Insurance Charges(CLI)</td>
                            <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                            <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                            <td style={{ borderWidth: '1px' }}>One-time</td>
                            <td style={{ borderWidth: '1px' }}>{camDetails?.cam_kotak_li_amount}</td>
                        </tr> 

                        <tr> 
                            <td style={{ borderWidth: '1px' }}>(iii)</td>
                            <td style={{ borderWidth: '1px' }}>Any other (please specify)(Document Charges )</td>
                            <td style={{ borderWidth: '1px' }}>One-time</td>
                            <td style={{ borderWidth: '1px' }}>{ /* camDetails?.cam_file_charges */ } {(Number(fileChargeExcludingGstAmt) || 0).toFixed(2)}</td>
                            <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                            <td style={{ borderWidth: '1px' }}>{(Number(fileChargeExcludingGst) || 0).toFixed(2)}&nbsp;</td>
                        </tr> 

                        <tr>  
                            <td style={{ borderWidth: '1px' }}  colSpan="6">&nbsp;</td>
                        </tr> 

                        <tr>  
                            <td style={{ borderWidth: '1px' }}  colSpan="1">9</td>
                            <td style={{ borderWidth: '1px' }}  colSpan="3">Annual Percentage Rate (APR) (%)</td>
                            <td style={{ borderWidth: '1px' }}  colSpan="2">{aprValue}%</td>
                        </tr> 

                        <tr>  
                            <td style={{ borderWidth: '1px' }}  colSpan="1">10</td>
                            <td style={{ borderWidth: '1px' }}  colSpan="5">Details of Contingent Charges (in INR or %, as applicable)</td>
                         </tr> 

                        <tr>  
                            <td style={{ borderWidth: '1px' }}  colSpan="6">&nbsp;</td>
                        </tr> 

                        <tr> 
                            <td style={{ borderWidth: '1px' }}>(i)</td>
                            <td style={{ borderWidth: '1px' }} colSpan="3">Penal charges, if any, in case of delayed payment</td>
                            <td style={{ borderWidth: '1px' }} colSpan="2">36% Per Annum</td>
                         </tr> 

                        <tr> 
                            <td style={{ borderWidth: '1px' }}>(ii)</td>
                            <td style={{ borderWidth: '1px' }} colSpan="3">Other penal charges, if any</td>
                            <td style={{ borderWidth: '1px' }} colSpan="2">
                                i) Rs 800 For Cheque Bouncing  Charges<br/>                                           
                                ii) Rs 800 For Cheque 

                            </td>
                         </tr> 

                         <tr> 
                            <td style={{ borderWidth: '1px' }}>(iii)</td>
                            <td style={{ borderWidth: '1px' }} colSpan="3">Foreclosure charges, if applicable</td>
                            <td style={{ borderWidth: '1px' }} colSpan="2">                                
                                 i) 4% Plus GST (Before Completion of  12 months repayment) <br/>                                                                         
                                ii) 2% (Post Completion of 12 Months Repayment)
                            </td>
                         </tr> 

                          <tr> 
                            <td style={{ borderWidth: '1px' }}>(iv)</td>
                            <td style={{ borderWidth: '1px' }} colSpan="3">Charges for switching of loans from floating to fixed rate and vice versa</td>
                            <td style={{ borderWidth: '1px' }} colSpan="2"> Not Applicable</td>
                         </tr> 

                          <tr> 
                            <td style={{ borderWidth: '1px' }}>(v)</td>
                            <td style={{ borderWidth: '1px' }} colSpan="3">Any other charges (please specify)</td>
                            <td style={{ borderWidth: '1px' }} colSpan="2">&nbsp;</td>
                         </tr> 


                          <tr>  
                            <td style={{ borderWidth: '1px' }}  colSpan="6">&nbsp;</td>
                         </tr> 

                          <tr> 
                            <td style={{ borderWidth: '1px',textAlign:'center', background: "rgba(145, 158, 171, 0.16)" }} colSpan="6"><h6> Part 2 (Other Qualitative Information)</h6></td>
                        </tr>

                        <tr> 
                            <td style={{ borderWidth: '1px' }}>1</td>
                            <td style={{ borderWidth: '1px' }} colSpan="3">Clause of Loan Agreement relating to engagement of Recovery Agents</td>
                            <td style={{ borderWidth: '1px' }} colSpan="2"> Clause 12.7 - Engagement of Specialized Agencies</td>
                         </tr> 
                         
                         <tr> 
                            <td style={{ borderWidth: '1px' }}>2</td>
                            <td style={{ borderWidth: '1px' }} colSpan="3">Clause of Loan Agreement which details Grievance Redressal Mechanism</td>
                            <td style={{ borderWidth: '1px' }} colSpan="2">{camDetails?.cam_lender ==='Vivriti' ? "Article 16" : ""}</td>
                         </tr>

                         <tr> 
                            <td style={{ borderWidth: '1px' }}>3</td>
                            <td style={{ borderWidth: '1px' }} colSpan="3">Phone Number and Email Id of the Nodal Grievance Redressal Officer</td>
                            <td style={{ borderWidth: '1px' }} colSpan="2">{camDetails?.cam_lender ==='Vivriti' ? (<>
                            <b>Grievance Redressal Officer:</b> Ajit K Menon, Group Chief Operating Officer.<br/> 
                            <b>Address:</b> Prestige Zackria Metropolitan, No.200/1-8, 2nd Floor, Block 1, Anna Salai, Chennai 600002<br/>
                            <b>Contact Details (Telephone/Email):</b> 044- 40074801/ grievanceredressal@vivriticapital.com

                            <hr/>

                            <b>cKers Finance Private Limited</b> ,<br/>  
                            <b>Grievance Redressal Officer:</b> Vivek Bhardwaj, Group Chief Operating Officer.<br/> 
                            <b>Address:</b>Building No. 24-30, First Floor, Okhla Industrial Estate, Phase III, New Delhi-110020, CIN: U65910DL2016PTC291909, 
                            <br/>
                            Ph. No: 011-41070629, Email: gro@ckersfinance.in 
                            </>) : 
                        (<>
                            <b>cKers Finance Private Limited</b> ,<br/>  
                            <b>Grievance Redressal Officer:</b> Vivek Bhardwaj, Group Chief Operating Officer.<br/> 
                            <b>Address:</b>Building No. 24-30, First Floor, Okhla Industrial Estate, Phase III, New Delhi-110020, CIN: U65910DL2016PTC291909, 
                            <br/>
                            Ph. No: 011-41070629, Email: gro@ckersfinance.in   
                        </>) 
                        }</td>
                         </tr>

                         <tr> 
                            <td style={{ borderWidth: '1px' }}>4</td>
                            <td style={{ borderWidth: '1px' }} colSpan="3"> Whether the Loan is or in future may be, subject to transfer to other REs or Securitisation (Yes/No)</td>
                            <td style={{ borderWidth: '1px' }} colSpan="2">Yes</td>
                         </tr>

                         <tr> 
                            <td style={{ borderWidth: '1px' }}>5</td>
                            <td style={{ borderWidth: '1px' }} colSpan="5"><b>In case of lending under collaborative lending arrangements (e.g., co-lending/ outsourcing), following additional details may be furnished : </b></td>
                            
                         </tr>

                         <tr> 
                            <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                            <td style={{ borderWidth: '1px' }} colSpan="2"> Name of the originating RE, along
 with its funding proportion</td>
                            <td style={{ borderWidth: '1px' }} colSpan="2"> Name of the partner RE along with its
 proportion of funding</td>
                             <td style={{ borderWidth: '1px' }} colSpan="1" >Blended rate of interest</td>
                         </tr>

                         <tr> 
                            <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                            <td style={{ borderWidth: '1px' }} colSpan="2">{camDetails?.cam_lender ==='Vivriti' ? " Ckers Finance Pvt Ltd (0%)" : "100%"}</td>
                            <td style={{ borderWidth: '1px' }} colSpan="2">{camDetails?.cam_lender ==='Vivriti' ? "Vivriti Capital Limited (100%)" : "0%"}</td>
                             <td style={{ borderWidth: '1px' }} colSpan="1" >{camDetails?.irr_flat_rate ? `${camDetails.irr_flat_rate}%` : ''}</td>
                         </tr>

                        <tr> 
                            <td style={{ borderWidth: '1px' }}>6</td>
                            <td style={{ borderWidth: '1px' }} colSpan="5"> <b>In case of digital loans, following specific disclosures may be furnished:</b></td>
                         </tr>

                          <tr> 
                            <td style={{ borderWidth: '1px' }}>(i)</td>
                            <td style={{ borderWidth: '1px' }} colSpan="3">Cooling off/look-up period, in terms of RE’s board approved policy, during which borrower shall  not  be  
charged  any  penalty  on prepayment of loan</td>
                            <td style={{ borderWidth: '1px' }} colSpan="2">Not Applicable</td>
                         </tr>

                          <tr> 
                            <td style={{ borderWidth: '1px' }}>(ii)</td>
                            <td style={{ borderWidth: '1px' }} colSpan="3">Details of LSP acting as Recovery Agent and authorized to approach the Borrower</td>
                            <td style={{ borderWidth: '1px' }} colSpan="2">{camDetails?.cam_lender ==='Vivriti' ? "Ckers Finance Private Limited" : "Will be notified through message or email"}</td>
                         </tr>


                         <tr>  
                            <td style={{ borderWidth: '1px' , height:"100px", textAlign:"right" }}  colSpan="6">
                                <h6>Accepted and Signed By</h6><br/>
                                (Borrower)

                            </td>
                         </tr>



                        <tr> 
                            <td style={{ borderWidth: '1px',textAlign:'center', background: "rgba(145, 158, 171, 0.16)" }} colSpan="6"><h6>Computation of APR</h6></td>
                        </tr>

                        <tr> 
                            <td style={{ borderWidth: '1px' }}><b>S.No.</b></td>
                            <td style={{ borderWidth: '1px' }} colSpan="3"><b>Parameter</b></td>
                            <td style={{ borderWidth: '1px' }} colSpan="2"><b>Details</b>&nbsp;</td>
                         </tr>	


                        <tr> 
                            <td style={{ borderWidth: '1px' }}>1</td>
                            <td style={{ borderWidth: '1px' }} colSpan="3">Sanctioned Loan Amount (in Rupees) (Sl No. 2 of the KFS template- Part 1)</td>
                            <td style={{ borderWidth: '1px' }} colSpan="2">{camDetails?.dmemo_funding_per_vehicle}&nbsp;</td>
                         </tr>		


                        <tr> 
                            <td style={{ borderWidth: '1px' }}>2</td>
                            <td style={{ borderWidth: '1px' }} colSpan="3">Loan Term (months) (Sl No.4 of the KFS template- Part 1)</td>
                            <td style={{ borderWidth: '1px' }} colSpan="2">{sLTenure}&nbsp;</td>
                         </tr>		

                        <tr> 
                            <td style={{ borderWidth: '1px' }}>(a)</td>
                            <td style={{ borderWidth: '1px' }} colSpan="3">No. of instalments for payment of principal, in case of non- equated periodic loans</td>
                            <td style={{ borderWidth: '1px' }} colSpan="2">{sLTenure} &nbsp;</td>
                         </tr>
                        <tr> 
                            <td style={{ borderWidth: '1px' }}>(b)</td>
                            <td style={{ borderWidth: '1px' }} colSpan="3">Type of EPI</td>
                            <td style={{ borderWidth: '1px' }} colSpan="2"> &nbsp;</td>
                         </tr>								
	
    
                        <tr> 
                            <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                            <td style={{ borderWidth: '1px' }} colSpan="3">Amount of each EPI (in Rupees) and</td>
                            <td style={{ borderWidth: '1px' }} colSpan="2"> {(Number(camDetails?.dmemo_emi_all_vehicle) || 0).toFixed(2)}&nbsp;</td>
                         </tr>		
	
    
                        <tr> 
                            <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                            <td style={{ borderWidth: '1px' }} colSpan="3">Nos. of EPIs (e.g., no. of EMIs in case of monthly installments)</td>
                            <td style={{ borderWidth: '1px' }} colSpan="2">{sLTenure}&nbsp;</td>
                         </tr>		
	
                        <tr> 
                            <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                            <td style={{ borderWidth: '1px' }} colSpan="3">(Sl No. 5 of the KFS template- Part1)</td>
                            <td style={{ borderWidth: '1px' }} colSpan="2">&nbsp;</td>
                         </tr>		


                         <tr> 
                            <td style={{ borderWidth: '1px' }}>(c)</td>
                            <td style={{ borderWidth: '1px' }} colSpan="3">No. of installments for payment of capitalized interest, if any</td>
                            <td style={{ borderWidth: '1px' }} colSpan="2">{sLTenure}&nbsp;</td>
                         </tr>		
  
                        <tr> 
                            <td style={{ borderWidth: '1px' }}>(d)</td>
                            <td style={{ borderWidth: '1px' }} colSpan="3">Commencement of repayments, post sanction (Sl No. 5 of the KFS template- Part 1)</td>
                            <td style={{ borderWidth: '1px' }} colSpan="2">5th of every month</td>
                         </tr>								


                        <tr> 
                            <td style={{ borderWidth: '1px' }}>3</td>
                            <td style={{ borderWidth: '1px' }} colSpan="3">Interest rate type (fixed or floating or hybrid) (Sl No. 6 of the KFS template- Part 1)</td>
                            <td style={{ borderWidth: '1px' }} colSpan="2">Fixed&nbsp;</td>
                         </tr>		


                        <tr> 
                            <td style={{ borderWidth: '1px' }}>4</td>
                            <td style={{ borderWidth: '1px' }} colSpan="3">Rate of Interest (Sl No. 6 of the KFS template- Part 1)</td>
                            <td style={{ borderWidth: '1px' }} colSpan="2">{camDetails?.dmemo_irr}%&nbsp;</td>
                         </tr>		


                        <tr> 
                            <td style={{ borderWidth: '1px' }}>5</td>
                            <td style={{ borderWidth: '1px' }} colSpan="3">Total Interest Amount to be charged during the entire tenor of the loan as per the rate prevailing on sanction date (in Rupees)</td>
                            <td style={{ borderWidth: '1px' }} colSpan="2">{(Number(camDetails?.irr_total_interest) || 0).toFixed(2)}&nbsp;</td>
                         </tr>		


                         <tr> 
                            <td style={{ borderWidth: '1px' }}>6</td>
                            <td style={{ borderWidth: '1px' }} colSpan="3">Fee/ Charges payable (in Rupees)</td>
                            <td style={{ borderWidth: '1px' }} colSpan="2"> { /* feeChargesPayable */}
                             
                                {(Number(totalFeeChargesPayable) || 0).toFixed(2)}
                                { /* (Number(camDetails?.dmemo_processing_fee_including_gst) || 0).toFixed(2) */ }&nbsp;</td> 
                         </tr>		


                        <tr> 
                            <td style={{ borderWidth: '1px' }}>A</td>
                            <td style={{ borderWidth: '1px' }} colSpan="3">Payable to the RE (Sl No. 8A of the KFS template- Part 1)</td>
                            <td style={{ borderWidth: '1px' }} colSpan="2">{(Number(payableTotheREAmount) || 0).toFixed(2)}&nbsp;</td>
                         </tr>								


                        <tr> 
                            <td style={{ borderWidth: '1px' }}>B</td>
                            <td style={{ borderWidth: '1px' }} colSpan="3">Payable to third- party routed through RE (Sl No. 8B of the KFS template- Part 1)</td>
                            <td style={{ borderWidth: '1px' }} colSpan="2">{(Number(payableToThirdPartyRoutedThroughRE) || 0).toFixed(2)}&nbsp;</td>
                         </tr>	

                         
                         <tr> 
                            <td style={{ borderWidth: '1px' }}>7</td>
                            <td style={{ borderWidth: '1px' }} colSpan="3">Document charge</td>
                            <td style={{ borderWidth: '1px' }} colSpan="2">{(Number(camDetails?.dmemo_file_charge) || 0).toFixed(2)}&nbsp;</td>
                         </tr>

                       {/*  <tr> 
                            <td style={{ borderWidth: '1px' }}>8</td>
                            <td style={{ borderWidth: '1px' }} colSpan="3">Insurance charge (CLI)</td>
                            <td style={{ borderWidth: '1px' }} colSpan="2">{(Number(camDetails?.dmemo_kli_amount) || 0).toFixed(2)}&nbsp;</td>
                         </tr>	

                         <tr> 
                            <td style={{ borderWidth: '1px' }}>9</td>
                            <td style={{ borderWidth: '1px' }} colSpan="3">Insurance by Ckers</td>
                            <td style={{ borderWidth: '1px' }} colSpan="2">{(Number(camDetails?.dmemo_insurance_by_cfpl) || 0).toFixed(2)}&nbsp;</td>
                         </tr>	*/ }							


                        <tr> 
                            <td style={{ borderWidth: '1px' }}>8</td>
                            <td style={{ borderWidth: '1px' }} colSpan="3">Net disbursed amount (1-6) (in Rupees)</td>
                            <td style={{ borderWidth: '1px' }} colSpan="2">{(Number(camDetails?.dmemo_disbursement_amount_for_vehicle_including_box) || 0).toFixed(2)}&nbsp;</td>
                         </tr>		


                        <tr> 
                            <td style={{ borderWidth: '1px' }}>9</td>
                            <td style={{ borderWidth: '1px' }} colSpan="3">Total amount to be paid by the borrower (sum of 1 and 5) (in Rupees)</td>
                            <td style={{ borderWidth: '1px' }} colSpan="2">{(Number(camDetails?.irr_total_repayment) || 0).toFixed(2)}&nbsp;</td>
                         </tr>		


                        <tr> 
                            <td style={{ borderWidth: '1px' }}>10</td>
                            <td style={{ borderWidth: '1px' }} colSpan="3">Annual Percentage rate – Effective annualized interest rate (in percentage)[3] (Sl No. 9 of the KFS template- Part 1)</td>
                            <td style={{ borderWidth: '1px' }} colSpan="2">{aprValue}%&nbsp;</td>
                         </tr>		


                        <tr> 
                            <td style={{ borderWidth: '1px' }}>11</td>
                            <td style={{ borderWidth: '1px' }} colSpan="3">Schedule of disbursement as per terms and conditions</td>
                            <td style={{ borderWidth: '1px' }} colSpan="2">&nbsp;</td>
                         </tr>							


                        <tr> 
                            <td style={{ borderWidth: '1px' }}>12</td>
                            <td style={{ borderWidth: '1px' }} colSpan="3">Due date of payment of installment and interest</td>
                            <td style={{ borderWidth: '1px' }} colSpan="2">5th of Every Month&nbsp;</td>
                         </tr>

                        <tr> 
                            <td style={{ borderWidth: '1px' }} colSpan="6">       
                                 Note:- Please note that this Key Fact Statement is for the purpose of illustrative computation only as it is issued before the formation of the loan contract. Depending upon the actual amount and date of disbursement after the formation of the loan contract, there will be corresponding changes in the details of the parameters listed in the Key Fact Statement and also the repayment schedule (including pre-EMI details, if applicable) that will be issued post loan disbursement.</td> 		
                        </tr>



                         <tr>  
                            <td style={{ borderWidth: '1px' }}  colSpan="6">&nbsp;</td>
                         </tr> 

                          <tr> 
                            <td style={{ borderWidth: '1px',textAlign:'center', background: "rgba(145, 158, 171, 0.16)" }} colSpan="6"><h6> Loan Amortization Schedule</h6></td>
                        </tr> 
                          
                        <tr> 
                            <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                            <td style={{ borderWidth: '1px' }} colSpan="3">Interest Rate </td>
                            <td style={{ borderWidth: '1px' }} colSpan="2">{camDetails?.dmemo_irr || 0}%&nbsp;</td>
                        </tr>

                        <tr> 
                            <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                            <td style={{ borderWidth: '1px' }} colSpan="3">Loan Duration </td>
                            <td style={{ borderWidth: '1px' }} colSpan="2">{sLTenure}&nbsp;</td>
                        </tr>

                        <tr> 
                            <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                            <td style={{ borderWidth: '1px' }} colSpan="3">Payments per year </td>
                            <td style={{ borderWidth: '1px' }} colSpan="2">12</td>
                        </tr>

                        <tr> 
                            <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                            <td style={{ borderWidth: '1px' }} colSpan="3">Loan Amount </td>
                            <td style={{ borderWidth: '1px' }} colSpan="2">{camDetails?.dmemo_funding_per_vehicle}&nbsp;</td>
                        </tr>



        <tr> 
            <td style={{ borderWidth: '1px', background: "rgba(140, 169, 197, 0.16)"  }}>Payment Number</td>
            <td style={{ borderWidth: '1px' , background: "rgba(140, 169, 197, 0.16)"}} colSpan="2">Payment</td>
            <td style={{ borderWidth: '1px', background: "rgba(140, 169, 197, 0.16)" }}>Principal</td>
            <td style={{ borderWidth: '1px', background: "rgba(140, 169, 197, 0.16)" }}>Interest</td>
            <td style={{ borderWidth: '1px' , background: "rgba(140, 169, 197, 0.16)"}}>Balance</td>
        </tr>

        {schedule.map((row, index) => (
            <tr key={index}>
                <td style={{ borderWidth: '1px' }}>{row.paymentNumber}</td>
                <td style={{ borderWidth: '1px' }} colSpan="2">{row.payment}</td>
                <td style={{ borderWidth: '1px' }}>{row.principal}</td>
                <td style={{ borderWidth: '1px' }}>{row.interest}</td>
                <td style={{ borderWidth: '1px' }}>{row.balance}</td>
            </tr>
        ))}



                <tr>
                        <td colSpan="6">
                            <hr />
                            {downloadPdfType === 'bank' ? (
                            <h2 style={{ textAlign: 'center' }}>Lender Copy</h2>
                            ) : (
                            <h2 style={{ textAlign: 'center' }}>Client Copy</h2>
                            )}
                        </td>
                        </tr>

                    </table>  

                    


            </div>
            { /* KFS section  :  END HERE */ }                 
         </div>

      </div>
      <br/> 
          {( isReadyToModify && (userRoleType === 'Credit' || userRoleType === "Super Admin" || userRoleType === 'Superadmin')) ? (
            <>

             { savedSanctionDetailsInfo?.action_status  === '1' ? ( <> 
                { ( !enableUpdatePdfDetails) && (
                    <>
                    <div className='form-group text-end mb-2'>
                        <button className='btn btn-warning text-white float-right-'   onClick={() => handleDownloadPdf('client')}><i className="nav-icon bi bi-download">&nbsp;</i> Generate Client PDF</button>&nbsp;

                        <button className='btn btn-warning text-white float-right-'   onClick={() => handleDownloadPdf('bank')}><i className="nav-icon bi bi-download">&nbsp;</i> Generate Bank PDF</button>&nbsp;
                    </div>
                 </>
                )}
             </> ) :
             (
                <>
                { ( !enableUpdatePdfDetails) ? (
                <button type="button" className="btn btn-primary text-white" onClick={handleToggleUpdateDetails} >Update Details</button>
                ) : (
                    <>
                    <button type="button" className="btn btn-primary text-white" onClick={handleToggleSaveDetails} >Save Details</button>

                    &nbsp;<button type="button" className="btn btn-danger text-white" onClick={handleToggleUpdateDetails} >Cancel</button>
                    </>
                )}

                { ( !enableUpdatePdfDetails) && (
                    
                    <>
                    <div className='form-group text-end mb-2'>
                    <button className='btn btn-warning text-white float-right-'   onClick={() => handleDownloadPdf('client')}><i className="nav-icon bi bi-download">&nbsp;</i> Generate Client PDF</button>&nbsp;

                    <button className='btn btn-warning text-white float-right-'   onClick={() => handleDownloadPdf('bank')}><i className="nav-icon bi bi-download">&nbsp;</i> Generate Bank PDF</button>&nbsp;
                    </div>
                    </>
                )}

                </>
            )}

                { (savedSanctionDetailsInfo?.action_status  > 0  && savedSanctionDetailsInfo?.action_status  < 3) && ( 
                    <> 
                     <button className="btn btn-danger float-right" type="button" onClick={() => btnOpenRejectData('3')} > Reversal Request </button>
                    </>
                 )} 
                </>

            ) : (
                <></>
            )} 


                { ( isReadyToModify && (userRoleType === 'Credit Head' || userRoleType === "Super Admin" || userRoleType === 'Superadmin' ) && refNo !=='' ) ? (
                  
                  <>
                    <div className='form-group text-end mb-2'>
                        <button className="btn btn-success" type="button"  onClick={() => btnOpenRejectData('1')}> Approve</button>&nbsp;
                       
                        <button className="btn btn-danger" type="button" onClick={() => btnOpenRejectData('2')} > Reject </button>
                    </div> 

                   
                    </>
                  
                ) : (
                  <>
                 
                   { isReadyToModify && showSanctionNote !== "" && (sanctionApproveLatestStatus === '1'  && userRoleType !== 'User')  && sanctionApproveAndSendMailLatestStatus < 1 && (
                     <div className='form-group text-end mb-2'>
                         <button className="btn btn-success" type="button"  onClick={() => btnOpenRejectData('1','1')} title="Send mail to Customer, Sales Person, CAM email and Logged-in user"> Send Mail </button>&nbsp; 
                 </div> 
                   )}
                  </>
              )}


                { ( !enableUpdatePdfDetails && userRoleType === 'User') && (
                    
                    <>
                    <div className='form-group text-end mb-2'>
                    <button className='btn btn-warning text-white float-right-'   onClick={() => handleDownloadPdf('client')}><i className="nav-icon bi bi-download">&nbsp;</i> Generate Client PDF</button>&nbsp;

                    <button className='btn btn-warning text-white float-right-'   onClick={() => handleDownloadPdf('bank')}><i className="nav-icon bi bi-download">&nbsp;</i> Generate Bank PDF</button>&nbsp;
                    </div>
                    </>
                )}

 
            { showSanctionNote !== ""   && (
                <div className={sanctionApproveLatestStatus=== '0' ? "text-end text-primary" : ( sanctionApproveLatestStatus=== '1' ? "text-end text-success" : "text-end text-red" )}>{showSanctionNote}</div>
                )}  
        
       
    </div>
 </>
)
}

</div>
</div>
</div>

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
            >
                <div className='modal-custom rounded'>
                    <div className='modal-head'>
                        <h4 id="modal-title">Lead Document</h4>
                    </div>

                    <div className='modal-body'>
                        <div className='row mb-2 pb-1'>
                            <div className='col-1'>&nbsp;</div>
                            <div className='col-10 ps-0'>{viewModalInfo.note}</div>
                        </div>
                    </div>
                </div>
            </Modal>

             {/* Reject REGISTRATION MODAL START */}
                  <Modal open={openRejectAmt} onClose={handleCloseRejectAmt} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                        <div className='modal-custom rounded'>
                          <div className='modal-head'>
                            <h4 id="modal-title">Enter Notes </h4>
                            <Button onClick={handleCloseRejectAmt} color="primary" className='btn'>
                              <i className="bi bi-x"> &nbsp;</i>
                            </Button>
                          </div>
            
                          <div className='modal-body'>
                            <form onSubmit={handleSubmit(handleRejectFormSubmit)} encType="multipart/form-data">
                              <div className="row mx-0">
                                
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label htmlFor="itr_file">
                                      <span>Notes <a style={{ color: "red" }}>*</a></span> 
                                        < textarea
                                            id='notes'
                                            name='notes'
                                            className='form-control'
                                            {...register('notes')}
                                             onChange={handleAmtRejectChange}
                                           
                                        />
            </label>
                                  </div>
                                </div>
            
                            
            
                                <div className="col-md-12">
                                  <div className="form-group mb-0">
                                    <button className="btn btn-primary mt-2">
                                      Save
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </Modal>
                    {/* Reject REGISTRATION MODAL END */}
        </>
    );
}


function mapStateToProps(state) {
    return {
        usersData: state.usersData,
        getUserModuleData: state.getUserModuleData,
        getUploadLeadDocument: state.getUploadLeadDocument,
        masterDocumentTypeData: state.masterDocumentTypeData,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign(userActions.default, leadActions.default), dispatch),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(SanctionLetter);
